import { useState } from "react"
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
import LazyLoad from "react-lazyload"

const Admission = () => {
  const homeMenu = [
    { label: "Admission Notification ", link: "/howtoapply" },
    { label: "Fee Structure", link: "/feestructure" },
    { label: "Prospectus ", link: "/Prospectus" },
    { label: "Virtual School Tour ", link: "https://iviewd.com/lotus_valley_gurgaon/" },
    { label: "School Schedule ", link: "/schoolSchedule" },
    {
      label: "Transport", link: "", subMenu: [
        { label: "Transport", link: "/transport" },
        { label: "Bus Routes", link: "/busRoute" },
      ]
    },

    { label: "Special Education", link: "/specialEdu" },
    { label: "Bonding With Parents", link: "/bondingwithparents" },
    // // { label: "Career Counselling", link: "/careerCounselling" },
    { label: "Meal Menu", link: "https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/School-Menu.pdf" },
    { label: "CBSE Results", link: "/CBSEResult" },
    { label: "Transfer Certificate", link: "/tc" },
  ]
  const [yearSelection, setYearSelection] = useState("0")
  const selectedYear = (value) => {
    setYearSelection(value);
  }
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/admissions-banner.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page admission_txt">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle pageTitle="Admissions" breadEnd="Admissions" breadMid="Admissions" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p>“The very substance of the ambitious is merely the shadow of a dream.” – William Shakespeare</p>
              <p>Achievement is never an accident. It is always a result of commitment to excellence, intelligent planning and a focused approach. The determined and passionate efforts of our learners have helped them secure admission into prestigious national and international institutes.</p>
              <p>Heartiest Congratulations to our learners!</p>
            </div>
            <hr class="separator m-auto my-4" style={{ width: "70%" }} />
            <div className="col-lg-12 text-center mb-4">
              <select className="float-end p-2" onChange={(e) => selectedYear(e.target.value)}>
                <option value="0">Year 2024-25</option>
                <option value="1">Year 2023-24</option>
                <option value="2">Year 2022-23</option>
                <option value="3">Year 2021-22</option>
                <option value="4">Year 2020-21</option>
                <option value="5">Year 2019-20</option>
                <option value="6">Year 2018-19</option>
                <option value="6">Year 2017-18</option>
                <option value="7">Year 2016-17</option>
                <option value="9">Year 2015-16</option>

              </select>
            </div>
            <div className="col-md-12">
              {yearSelection === "0" && (
                <div class="" >
                  <div class="heading2 text-center mb-4">
                    <h4><b>ADMISSIONS AT THE NATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/AAIRA-KATOCH.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">AAIRA KATOCH</p>
                          <p>NATIONAL INSTITUTE OF DESIGN (NID)</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ARYAN-YADAV.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ARYAN YADAV</p>
                          <p>IIM, ROHTAK</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/DHANISHTA-KAUL.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">DHANISHTA KAUL</p>
                          <p>LSR,DELHI UNIVERSITY </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/GAURI-SHARMA.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">GAURI SHARMA</p>
                          <p>NATIONAL LAW UNIVERSITY, DELHI</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/MAANYA-RAJPUT.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">MAANYA RAJPUT</p>
                          <p>SHAHEED SUKHDEV COLLEGE OF BUSINESS STUDIES, DELHI UNIVERSITY </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/MANASVI-AGARWAL.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">MANASVI AGARWAL</p>
                          <p>BITS DESIGN SCHOOL, MUMBAI</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/MEGHA-ANAND.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">MEGHA ANAND</p>
                          <p>BITS DESIGN SCHOOL, MUMBAI</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/MRRIDUL-SESHADRI.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">MRRIDUL SESHADRI</p>
                          <p>BITS,  PILANI</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/NAINA-JHAAMB.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">NAINA JHAAMB</p>
                          <p>SRCC, DELHI UNIVERSITY </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/NIHARIKA-BHARDWAJ.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">NIHARIKA BHARDWAJ</p>
                          <p>LAKSHMIBAI COLLEGE, DELHI UNIVERSITY </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/SANA-MEHTA.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SANA MEHTA</p>
                          <p>NATIONAL UNIVERSITY OF JURIDICAL SCIENCES, KOLKATA </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/SHANIA-SINGH.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SHANIA SINGH</p>
                          <p>BITS DESIGN SCHOOL, MUMBAI</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/VANSH-SRIVASTAVA.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">VANSH SRIVASTAVA</p>
                          <p>NATIONAL LAW UNIVERSITY JODHPUR</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/YASHICA-VIJ.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">YASHICA VIJ </p>
                          <p>NIFT, GANDHINAGAR</p>
                        </div>
                      </div>
                    </div>


                  </div>
                  <div class="table">
                    <table border="1" width="100%" className="table-view">
                      <tbody>
                        <tr className="font-normal">
                        <th> S.No.</th>
                        <th>LEARNER’S&nbsp; NAME&nbsp;</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal"><td>	1	</td><td>	AADIT SAWHNEY	</td><td>	SHIV NADAR UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	2	</td><td>	AGASTYA GOSWAMY 	</td><td>	O.P JINDAL UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	3	</td><td>	AISHIKA CHADHA	</td><td>	INDRAPRASTHA UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	4	</td><td>	AKSHITA VATS	</td><td>	SHIV NADAR UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	5	</td><td>	ALIYA GOPAL SINGH	</td><td>	VEDATYA INSTITUTE, GURUGRAM	</td></tr>
                         <tr className="font-normal"><td>	6	</td><td>	ANGEL KHANNA	</td><td>	ASHOKA UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	7	</td><td>	ANJANA SRIRAM	</td><td>	NIRMA UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	8	</td><td>	ANUSHKA MENON	</td><td>	ATLAS SKILLTECH UNIVERSITY, MUMBAI	</td></tr>
                         <tr className="font-normal"><td>	9	</td><td>	ARNAV GUPTA	</td><td>	PLAKSHA UNIVERSITY	</td></tr>
                         <tr className="font-normal"><td>	10	</td><td>	ARSHIYA JOSHI 	</td><td>	ASHOKA UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	11	</td><td>	ATULYA SAHAY 	</td><td>	SRM INSTITUTE OF SCIENCE AND TECHNOLOGY,KATHHANKULTHAR	</td></tr>
                         <tr className="font-normal"><td>	12	</td><td>	AYAAN SINGH	</td><td>	CHRIST UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	13	</td><td>	BHAVYA GUPTA	</td><td>	IIAD GURUGRAM IN AFFILIATION WITH KINGSTON UNIVERSITY	</td></tr>
                         <tr className="font-normal"><td>	14	</td><td>	BIJAL RAWAT	</td><td>	SYMBIOSIS LAW SCHOOL	</td></tr>
                         <tr className="font-normal"><td>	15	</td><td>	DEVANSH SHARMA	</td><td>	NIRMA UNIVERSITY	</td></tr>
                         <tr className="font-normal"><td>	16	</td><td>	DHRUV NAGWANI 	</td><td>	THAPAR INSTITUTE OF ENGINEERING &amp; TECHNOLOGY	</td></tr>
                         <tr className="font-normal"><td>	17	</td><td>	DHRUV RASTOGI 	</td><td>	OP JINDAL GLOBAL UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	18	</td><td>	GARGI ROY	</td><td>	KREA UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	19	</td><td>	ISHA GOSAIN	</td><td>	FLAME UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	20	</td><td>	JHANVI JALAN	</td><td>	SHIV NADAR UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	21	</td><td>	KESHAVA PIYUSH PRASAD	</td><td>	PLAKSHA UNIVERSITY	</td></tr>
                         <tr className="font-normal"><td>	22	</td><td>	KIRAT JABBAL	</td><td>	NMIMS 	</td></tr>
                         <tr className="font-normal"><td>	23	</td><td>	KRISHANG MAHESHWARI	</td><td>	MANIPAL ACADEMY OF HIGHER EDUCATION	</td></tr>
                         <tr className="font-normal"><td>	24	</td><td>	MAMILLA SAI ROHAN	</td><td>	K. R. MANGALAM UNIVERSITY, GURUGRAM	</td></tr>
                         <tr className="font-normal"><td>	25	</td><td>	MYSHA SHARMA	</td><td>	OP JINDAL GLOBAL UNIVERSITY	</td></tr>
                         <tr className="font-normal"><td>	26	</td><td>	NAYSA BILLA 	</td><td>	OP JINDAL GLOBAL UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	27	</td><td>	NILABH DAS 	</td><td>	ASHOKA UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	28	</td><td>	NISHIT SARAF 	</td><td>	PLAKSHA	</td></tr>
                         <tr className="font-normal"><td>	29	</td><td>	NITYA JADIA	</td><td>	JINDAL GLOBAL LAW COLLEGE / SYMBIOSIS	</td></tr>
                         <tr className="font-normal"><td>	30	</td><td>	OJAL BASWANI	</td><td>	MIT ADT UNIVERSITY	</td></tr>
                         <tr className="font-normal"><td>	31	</td><td>	PRATHAM SETHI 	</td><td>	FLAME UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	32	</td><td>	SACHI RAJPUT	</td><td>	MANIPAL ACADEMY OF HIGHER EDUCATION	</td></tr>
                         <tr className="font-normal"><td>	33	</td><td>	SARA GUPTA	</td><td>	VELLORE INSTITUTE OF TECHNOLOGY (VIT)	</td></tr>
                         <tr className="font-normal"><td>	34	</td><td>	SHREYANS BHARGAVA	</td><td>	THAPAR INSTITUTE OF ENGINEERING &amp; TECHNOLOGY	</td></tr>
                         <tr className="font-normal"><td>	35	</td><td>	TARISHI DIXIT 	</td><td>	SHOOLINI UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	36	</td><td>	TUHINA TULI	</td><td>	GD GOENKA UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	37	</td><td>	TURVISHI ARORA	</td><td>	ASHOKA UNIVERSITY	</td></tr>
                         <tr className="font-normal"><td>	38	</td><td>	VIDITA SINGH ATRI	</td><td>	ASHOKA UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>	39	</td><td>	YASH CHAWLA	</td><td>	OP JINDAL GLOBAL UNIVERSITY	</td></tr>



                      </tbody></table>
                  </div>
                  <div class="heading2 text-center mt-4 mb-4">
                    <h4><b>ADMISSIONS AT THE INTERNATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/AARAV-GUPTA.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">AARAV GUPTA	</p>
                          <p>THE GEORGE WASHINGTON UNIVERSITY, USA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ABHIMANYU-ARORA.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ABHIMANYU ARORA	</p>
                          <p>EMORY UNIVERSITY, USA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/AKSHAT-SHARMA.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">AKSHAT SHARMA	</p>
                          <p>RUTGERS UNIVERSITY - NEW BRUNSWICK, USA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ANISHA-GUPTA.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ANISHA GUPTA</p>
                          <p>UNIVERSITY OF MELBOURNE, AUSTRALIA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ARNAV-MALHOTRA.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ARNAV MALHOTRA</p>
                          <p>UNIVERSITY OF MELBOURNE , AUSTRALIA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ARNAV-RAI-AGARWAL.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ARNAV RAI AGARWAL</p>
                          <p>PENNSYLVANIA STATE UNIVERSITY, USA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ARYA-JAIN.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ARYA JAIN</p>
                          <p>PENNSYLVANIA STATE UNIVERSITY, USA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/AYAAN-BHOLA.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">AYAAN BHOLA	</p>
                          <p>THE UNIVERSITY OF MINNESOTA TWIN CITIES, USA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/DHRUVIKAA-D-REDDY.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">DHRUVIKAA DODLA REDDY	</p>
                          <p>UNIVERSITY OF CALIFORNIA, LOS ANGELES</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/MAANSI-SINGH.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">MAANSI SINGH</p>
                          <p>SINGAPORE MANAGEMENT UNIVERSITY, SINGAPORE </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/MIHIKAA-SINGH.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">MIHIKAA SINGH</p>
                          <p>NATIONAL UNIVERSITY OF SINGAPORE,SINGAPORE  </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/SUHANI-SHARMA.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SUHANI SHARMA</p>
                          <p>DEAKIN UNIVERSITY, AUSTRALIA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/VAANIA-ARORA.jpg" />
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">VAANIA ARORA</p>
                          <p>UNIVERSITY OF WATERLOO, CANADA</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table border="1" width="100%" className="table-view">
                      <tbody><tr>
                        <th> S.No.</th>
                        <th>LEARNER’S&nbsp; NAME&nbsp;</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                         <tr className="font-normal"><td>	1	</td><td>	AARAV GUPTA	</td><td>	THE GEORGE WASHINGTON UNIVERSITY, USA	</td></tr>
                         <tr className="font-normal"><td>	2	</td><td>	ABHIMANYU ARORA	</td><td>	EMORY UNIVERSITY, USA	</td></tr>
                         <tr className="font-normal"><td>	3	</td><td>	AKSHAT SHARMA	</td><td>	RUTGERS UNIVERSITY - NEW BRUNSWICK, USA	</td></tr>
                         <tr className="font-normal"><td>	4	</td><td>	ANISHA GUPTA	</td><td>	UNIVERSITY OF MELBOURNE, AUSTRALIA	</td></tr>
                         <tr className="font-normal"><td>	5	</td><td>	ARNAV MALHOTRA	</td><td>	UNIVERSITY OF MELBOURNE , AUSTRALIA	</td></tr>
                         <tr className="font-normal"><td>	6	</td><td>	ARNAV RAI AGARWAL	</td><td>	PENNSYLVANIA STATE UNIVERSITY, USA	</td></tr>
                         <tr className="font-normal"><td>	7	</td><td>	ARYA JAIN	</td><td>	PENNSYLVANIA STATE UNIVERSITY, USA	</td></tr>
                         <tr className="font-normal"><td>	8	</td><td>	AYAAN BHOLA	</td><td>	THE UNIVERSITY OF MINNESOTA TWIN CITIES, USA	</td></tr>
                         <tr className="font-normal"><td>	9	</td><td>	DHRUVIKAA DODLA REDDY	</td><td>	UNIVERSITY OF CALIFORNIA, LOS ANGELES	</td></tr>
                         <tr className="font-normal"><td>	10	</td><td>	MAANSI SINGH	</td><td>	SINGAPORE MANAGEMENT UNIVERSITY, SINGAPORE 	</td></tr>
                         <tr className="font-normal"><td>	11	</td><td>	MIHIKAA SINGH	</td><td>	NATIONAL UNIVERSITY OF SINGAPORE,SINGAPORE  	</td></tr>
                         <tr className="font-normal"><td>	12	</td><td>	SUHANI SHARMA	</td><td>	DEAKIN UNIVERSITY, AUSTRALIA	</td></tr>
                         <tr className="font-normal"><td>	13	</td><td>	VAANIA ARORA	</td><td>	UNIVERSITY OF WATERLOO, CANADA	</td></tr>



                      </tbody></table>
                  </div>
                </div>
              )
              }
              {yearSelection === "1" && (
                <div class="">
                  <div class="heading2 text-center mb-4">
                    <div class="heading2 text-center mb-4">
                      <h4><b>ADMISSIONS AT THE NATIONAL LEVEL</b></h4>

                    </div>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/SHAURYA-GUPTA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SHAURYA GUPTA</p>
                          <p>IIIT, HYDERABAD</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/TEJAL-DOSHI.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">TEJAL DOSHI</p>
                          <p>INDIAN INSTITUTE OF MANAGEMENT, INDORE</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ARAV-MATHUR.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">AARAV MATHUR</p>
                          <p>GOVERNMENT INSTITUTE OF MEDICAL SCIENCES , GREATER NOIDA, UP </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ISHAAN-CHHABRA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ISHAAN CHHABRA</p>
                          <p>NATIONAL LAW UNIVERSITY, DELHI</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/RAMDAS-SINGH.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">RAMDAS SINGH</p>
                          <p>INDIAN STATISTICAL INSTITUTE, BANGALORE</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th> S.No.</th>
                        <th>LEARNER'S&nbsp; NAME&nbsp;</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                         <tr className="font-normal"><td>1</td><td>	SHAURYA GUPTA</td><td>	IIIT, HYDERABAD</td></tr>
                         <tr className="font-normal"><td>2</td><td>	TEJAL DOSHI	</td><td>	INDIAN INSTITUTE OF MANAGEMENT, INDORE </td></tr>
                         <tr className="font-normal"><td>3</td><td>	AARAV MATHUR	</td><td>	GOVERNMENT INSTITUTE OF MEDICAL SCIENCES , GREATER NOIDA, UP	</td></tr>
                         <tr className="font-normal"><td>4</td><td>	ISHAAN CHHABRA	</td><td>	NATIONAL LAW UNIVERSITY, DELHI	</td></tr>
                         <tr className="font-normal"><td>5</td><td>	RAMDAS SINGH	</td><td>	INDIAN STATISTICAL INSTITUTE, BANGALORE	</td></tr>
                         <tr className="font-normal"><td>6</td><td>	RYAN PURI	</td><td>	SIDDHARTA MEDICAL COLLEGE, Vijaywada	</td></tr>
                         <tr className="font-normal"><td>7</td><td>	GAYATRI VEER 	</td><td>	LADY SHRI RAM COLLEGE FOR WOMEN, Delhi University	</td></tr>
                         <tr className="font-normal"><td>8</td><td>	SAANVI HORA	</td><td>	NIFT, BENGALURU 	</td></tr>
                         <tr className="font-normal"><td>9</td><td>	ASHWIKA GUPTA	</td><td>	IHM PUSA ROAD , DELHI	</td></tr>
                         <tr className="font-normal"><td>10	</td><td>	DHRUV KUMAR	</td><td>	SHRI JAGANNATH MEDICAL COLLEGE, PURI           	</td></tr>
                         <tr className="font-normal"><td>11	</td><td>	Vanshika Jain	</td><td>	LADY SHRI RAM COLLEGE, Delhi University	</td></tr>
                         <tr className="font-normal"><td>12	</td><td>	VINAYAK MALHOTRA	</td><td>	SHAHEED SUKHDEV COLLEGE OF BUSINESS STUDIES, Delhi University	</td></tr>
                         <tr className="font-normal"><td>13	</td><td>	AADYA MUKHERJEE	</td><td>	MANIPAL INSTITUTE OF TECHNOLOGY, Manipal	</td></tr>
                         <tr className="font-normal"><td>14	</td><td>	AAHANA RATHOR	</td><td>	CEPT UNIVERSITY, Ahmedabad	</td></tr>
                         <tr className="font-normal"><td>15	</td><td>	AANYA SINGH	</td><td>	BENNETT UNIVERSITY, Greater Noida, UP	</td></tr>
                         <tr className="font-normal"><td>16	</td><td>	AARAV NAVANI	</td><td>	FLAME, Pune	</td></tr>
                         <tr className="font-normal"><td>17	</td><td>	AARNAA BATRA	</td><td>	NIFT, Kangra	</td></tr>
                         <tr className="font-normal"><td>18	</td><td>	ADITI PANT	</td><td>	LADY IRWIN COLLEGE, Delhi University	</td></tr>
                         <tr className="font-normal"><td>19	</td><td>	ADVAY DANGI	</td><td>	DELHI COLLEGE OF ARTS AND COMMERCE (DCAC), Delhi University	</td></tr>
                         <tr className="font-normal"><td>20	</td><td>	ADYA PASSEY	</td><td>	ISDI, MUMBAI	</td></tr>
                         <tr className="font-normal"><td>21	</td><td>	AKSHAT RAMPAL	</td><td>	MAHE DEPARTMENT OF LIBERAL ARTS HUMANITIES AND SOCIAL SCIENCES	</td></tr>
                         <tr className="font-normal"><td>22	</td><td>	Ananya Sirohi	</td><td>	Sarla Anil Modi college of economics 	</td></tr>
                         <tr className="font-normal"><td>23	</td><td>	ANIRUDH GOVINDAN	</td><td>	VELLORE INSTITUTE OF TECHNOLOGY	</td></tr>
                         <tr className="font-normal"><td>24	</td><td>	ANOUSHKA SHARMA	</td><td>	ARYABHATTA COLLEGE(DELHI UNIVERSITY)	</td></tr>
                         <tr className="font-normal"><td>25	</td><td>	ANOUSHKA SHARMA	</td><td>	ARYABHATTA COLLEGE(DELHI UNIVERSITY)	</td></tr>
                         <tr className="font-normal"><td>26	</td><td>	Anoushka Sharma	</td><td>	KAMALA NEHRU COLLEGE, Delhi University	</td></tr>
                         <tr className="font-normal"><td>27	</td><td>	APURV BHUSHAN	</td><td>	PLAKSHA UNIVERSITY, Punjab University	</td></tr>
                         <tr className="font-normal"><td>28	</td><td>	ARNAV SINGH	</td><td>	VELLORE INSTITUTE OF TECHNOLOGY, Vellore 	</td></tr>
                         <tr className="font-normal"><td>29	</td><td>	DITYA BHUTTAN	</td><td>	FLAME UNIVERSITY, Pune	</td></tr>
                         <tr className="font-normal"><td>30	</td><td>	DIYA BHATNAGAR	</td><td>	GARGI COLLEGE, Delhi University	</td></tr>
                         <tr className="font-normal"><td>31	</td><td>	ERIN THOMAS	</td><td>	CHRIST UNIVERSITY,BANGALORE (MAIN CAMPUS)	</td></tr>
                         <tr className="font-normal"><td>32	</td><td>	GARV MULLICK	</td><td>	ANIL SURENDERA MODI SCHOOL OF COMMERCE, Maharashtra	</td></tr>
                         <tr className="font-normal"><td>33	</td><td>	GAURIKA KHANNA	</td><td>	CHRIST UNIVERSITY, CENTRAL CAMPUS, Bangalore	</td></tr>
                         <tr className="font-normal"><td>34	</td><td>	GITANJALI SINGH ATRI	</td><td>	PLAKSHA UNIVERSITY , Punjab	</td></tr>
                         <tr className="font-normal"><td>35	</td><td>	Gitanjali Singh Atri 	</td><td>	PLAKSHA, Punjab 	</td></tr>
                         <tr className="font-normal"><td>36	</td><td>	HARSIMRAN SINGH	</td><td>	MANIPAL UNIVERSITY, JAIPUR	</td></tr>
                         <tr className="font-normal"><td>37	</td><td>	HIYA DHADWAL 	</td><td>	FLAME UNIVERSITY, Pune 	</td></tr>
                         <tr className="font-normal"><td>38	</td><td>	Jaanvi  Pande	</td><td>	INDIA INTERNATIONAL UNIVERSITY OF LAW , Goa	</td></tr>
                         <tr className="font-normal"><td>39	</td><td>	JIYA MAHAJAN	</td><td>	FLAME UNIVERSITY, PUNE 	</td></tr>
                         <tr className="font-normal"><td>40	</td><td>	KABIR SIROHI DAHIYA 	</td><td>	KREA UNIVERSITY 	</td></tr>
                         <tr className="font-normal"><td>41	</td><td>	KESHAV YADAV 	</td><td>	NMIMS, BANGALORE 	</td></tr>
                         <tr className="font-normal"><td>42	</td><td>	KRIPA KAUR	</td><td>	KIRORI MAL COLLEGE, Delhi University	</td></tr>
                         <tr className="font-normal"><td>43	</td><td>	KRITARTH SHARAN	</td><td>	SRM INSTITUTE OF TECHNOLOGY, KTR	</td></tr>
                         <tr className="font-normal"><td>44	</td><td>	LAVANYA SRIVASTAVA	</td><td>	SYMBIOSIS SCHOOL OF LIBERAL ARTS, Pune	</td></tr>
                         <tr className="font-normal"><td>45	</td><td>	MADHAV MALHAN	</td><td>	ASHOKA UNIVERSITY, Punjab	</td></tr>
                         <tr className="font-normal"><td>46	</td><td>	MANYA ARORA	</td><td>	ANANT NATIONAL UNIVERSITY, Gujrat	</td></tr>
                         <tr className="font-normal"><td>47	</td><td>	MANYA JAIN	</td><td>	SRISHTI MANIPAL INSTITUTE OF ART, DESIGN AND TECHNOLOGY, Bangalore	</td></tr>
                         <tr className="font-normal"><td>48	</td><td>	MARUSHIKA ARORA	</td><td>	HINDU COLLEGE, Delhi University	</td></tr>
                         <tr className="font-normal"><td>49	</td><td>	MRIGANKA SINGH	</td><td>	JINDAL BUSINESS SCHOOL, Haryana	</td></tr>
                         <tr className="font-normal"><td>50	</td><td>	NAINA TANDON	</td><td>	JESUS AND MARY COLLEGE, DELHI UNIVERSITY, Delhi University	</td></tr>
                         <tr className="font-normal"><td>51	</td><td>	NAVYA AGARWAL	</td><td>	OP JINDAL LAW SCHOOL, Noida	</td></tr>
                         <tr className="font-normal"><td>52	</td><td>	NAVYA KASERA	</td><td>	INDIAN INSTITUTE OF ART AND DESIGN, Delhi	</td></tr>
                         <tr className="font-normal"><td>53	</td><td>	NAVYA LAKHOTIA	</td><td>	MANIPAL INSTITUTE OF TECHNOLOGY, Manipal	</td></tr>
                         <tr className="font-normal"><td>54	</td><td>	NAVYA NANDINI DHODY 	</td><td>	PLAKSHA UNIVERSITY , Punjab	</td></tr>
                         <tr className="font-normal"><td>55	</td><td>	NAVYA SINGHAL	</td><td>	GUJARAT NATIONAL LAW UNIVERSITY, Gujrat	</td></tr>
                         <tr className="font-normal"><td>56	</td><td>	Nayantara Yadav	</td><td>	JINDAL SCHOOL OF GOVERNMENT POLICY, Haryana	</td></tr>
                         <tr className="font-normal"><td>57	</td><td>	NIA RANJAN 	</td><td>	NATIONAL INSTITUTE OF MEDICAL SCIENCES , Jaipur	</td></tr>
                         <tr className="font-normal"><td>58	</td><td>	NIHARIKA PALIWAL	</td><td>	BML, MUNJAL	</td></tr>
                         <tr className="font-normal"><td>59	</td><td>	NYESA JAIN	</td><td>	GD GOENKA UNIVERSITY, haryana	</td></tr>
                         <tr className="font-normal"><td>60	</td><td>	NYSA HITESH VAID	</td><td>	NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES - MUMBAI MAIN CAMPUS	</td></tr>
                         <tr className="font-normal"><td>61	</td><td>	PRANJAL SHARMA 	</td><td>	SUSHANT SCHOOL OF DESIGN, Haryana	</td></tr>
                         <tr className="font-normal"><td>62	</td><td>	PRITHVI SUBHASH JANGID 	</td><td>	NIRMA UNIVERSITY, AHMEDABAD	</td></tr>
                         <tr className="font-normal"><td>63	</td><td>	PRIYANSHI MATHUR	</td><td>	KALLINGA INSTITUTE OF INDUSTRIAL TECHNOLOGY, Orissa 	</td></tr>
                         <tr className="font-normal"><td>64	</td><td>	RISHIT RAMPAL	</td><td>	SYMBIOSIS INSTITUTE OF DESIGN, Pune	</td></tr>
                         <tr className="font-normal"><td>65	</td><td>	RITISHA MEHROTRA	</td><td>	CHRIST UNIVERSITY, YESHWANTHPUR, BENGALURU	</td></tr>
                         <tr className="font-normal"><td>66	</td><td>	RITISHA MEHROTRA	</td><td>	SYMBIOSIS COLLEGE OF MANAGEMENT STUDIES (SCMS) NOIDA	</td></tr>
                         <tr className="font-normal"><td>67	</td><td>	RIYA AGGARWAL	</td><td>	SHRISTI INSTITUTE OF ART, DESING AND TECHNOLOGY	</td></tr>
                         <tr className="font-normal"><td>68	</td><td>	RYAN PRADHAN DMELLO	</td><td>	CHRIST UINVERSITY	</td></tr>
                         <tr className="font-normal"><td>69	</td><td>	SABA TAHERYPOUR 	</td><td>	INDIAN SCHOOL OF HOSPITALITY, Gurgaon	</td></tr>
                         <tr className="font-normal"><td>70	</td><td>	SABA TAHERYPOUR 	</td><td>	IILM, Delhi	</td></tr>
                         <tr className="font-normal"><td>71	</td><td>	SAMYUKTHA KRISHNAN 	</td><td>	PEARL ACADEMY, WEST DELHI 	</td></tr>
                         <tr className="font-normal"><td>72	</td><td>	SARA KHURANA 	</td><td>	THAPAR INSTITUTE OF ENGINEERING AND TECHNOLOGY , Punjab	</td></tr>
                         <tr className="font-normal"><td>73	</td><td>	SAUMYA BABBAR	</td><td>	SRISHTI MANIPAL INSTITUTE OF ART, DESIGN AND TECHNOLOGY, Manipal	</td></tr>
                         <tr className="font-normal"><td>74	</td><td>	SHREYA MISHRA	</td><td>	JINDAL GLOBAL LAW SCHOOL,Haryana	</td></tr>
                         <tr className="font-normal"><td>75	</td><td>	SIA SATIJA	</td><td>	JESUS AND MARY COLLEGE, DELHI UNIVERSITY, Delhi University	</td></tr>
                         <tr className="font-normal"><td>76	</td><td>	TANISH SHARAN	</td><td>	FLAME UNIVERSITY, Pune	</td></tr>
                         <tr className="font-normal"><td>77	</td><td>	TANISHKA SHARMA 	</td><td>	ANIL SURENDRA MODI SCHOOL OF COMMERCE , Maharashtra	</td></tr>
                         <tr className="font-normal"><td>78	</td><td>	TANMAY SURI	</td><td>	HANSRAJ COLLEGE, Delhi University 	</td></tr>
                         <tr className="font-normal"><td>79	</td><td>	Tishia Katoch	</td><td>	JIMS, Rohini , Delhi	</td></tr>
                         <tr className="font-normal"><td>80	</td><td>	VANINI YAGNIK 	</td><td>	PEARL ACADEMY,DELHI	</td></tr>
                         <tr className="font-normal"><td>81	</td><td>	VIVAAN BATTISH	</td><td>	Anil Surendra Modi School Of Commerce, maharashtra	</td></tr>
                         <tr className="font-normal"><td>82	</td><td>	YATEE KAUSHIK	</td><td>	OP JINDAL GLOBAL UNIVERSITY, Haryana	</td></tr>
                         <tr className="font-normal"><td>83	</td><td>	NIKHIL KUMARIA 	</td><td>	BA (H) in Psychology 	</td></tr>


                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <div class="heading2 text-center mb-4">
                      <h4><b>
                        ADMISSIONS AT THE INTERNATIONAL LEVEL
                      </b></h4>
                    </div>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/SHAURYA-AGARWAL.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SHAURYA AGARWAL	</p>
                          <p>Cornell University, United States</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/AARUSH-YADAV.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">AARUSH YADAV </p>
                          <p>UNIVERSITY OF MELBOURNE , Australia</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/KATYA-SOOD.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">KATYA SOOD	</p>
                          <p>University of Amsterdam, Netherlands</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/YANA-JAIN.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">YANA JAIN 	</p>
                          <p>Lasalle college of Arts, Singapore </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/DEEPTI-KHETAN.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">DEEPTI KHETAN	</p>
                          <p>University of Illinois Urbana champagne, United States</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th> S.No.</th>
                        <th>LEARNER'S&nbsp; NAME&nbsp;</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                         <tr className="font-normal"><td>1	</td><td>SHAURYA AGARWAL	</td><td>	Cornell University, United States	</td></tr>
                         <tr className="font-normal"><td>2	</td><td>AARUSH YADAV 	</td><td>	UNIVERSITY OF MELBOURNE , Australia              	</td></tr>
                         <tr className="font-normal"><td>3	</td><td>KATYA SOOD	</td><td>	University of Amsterdam, Netherlands	</td></tr>
                         <tr className="font-normal"><td>4	</td><td>YANA JAIN 	</td><td>	Lasalle college of Arts, Singapore                                      	</td></tr>
                         <tr className="font-normal"><td>5	</td><td>DEEPTI KHETAN	</td><td>	University of Illinois Urbana champagne, United States               	</td></tr>
                         <tr className="font-normal"><td>6	</td><td>ABHIE GUPTA </td><td>	UNIVERSITY OF MELBOURNE, Australia</td></tr>
                         <tr className="font-normal"><td>7	</td><td>RAIMA GUHA 	</td><td>	THE UNIVERSITY OF MANCHESTER, England                               	</td></tr>
                         <tr className="font-normal"><td>8	</td><td>ARYAN VIR	</td><td>	Pennsylvania State University, United States	</td></tr>
                         <tr className="font-normal"><td>9	</td><td>HARSH VOHRA	</td><td>	DEAKIN UNIVERSITY,Australia      	</td></tr>
                         <tr className="font-normal"><td>10	</td><td>VRISHANK SINGH	</td><td>	ARIZONA STATE UNIVERSITY, United States	</td></tr>
                         <tr className="font-normal"><td>11	</td><td>Veer Upmanyu	</td><td>	PURDUE University, United States	</td></tr>
                         <tr className="font-normal"><td>12	</td><td>AARAV GARG	</td><td>	UNIVERSITY OF CALIFORNIA IRVINE, United States	</td></tr>
                         <tr className="font-normal"><td>13	</td><td>NORIZA PARMAR	</td><td>	UNIVERSITY OF THE WEST OF ENGLAND, England 	</td></tr>
                         <tr className="font-normal"><td>14	</td><td>SHOURYA KAPOOR	</td><td>	Northeastern University, United States	</td></tr>
                         <tr className="font-normal"><td>15	</td><td>IPSITA RAHEJA 	</td><td>	NUOVA ACCADEMIA DI BELLE ARTI ( NABA ) , Italy	</td></tr>
                         <tr className="font-normal"><td>16	</td><td>ANYA GUPTA	</td><td>	DURHAM UNIVERSITY, England	</td></tr>
                         <tr className="font-normal"><td>17	</td><td>ANYA GUPTA	</td><td>	DURHAM UNIVERSITY , England	</td></tr>
                         <tr className="font-normal"><td>18	</td><td>VIVAAN SAWHNEY	</td><td>	UNIVERSITY OF NEW SOUTH WALES, Australia	</td></tr>
                         <tr className="font-normal"><td>19	</td><td>DIYA VERMA	</td><td>	TORONTO METROPOLITAN UNIVERSITY, Canada	</td></tr>
                         <tr className="font-normal"><td>20	</td><td>TANAY SHARMA	</td><td>	UNIVERSITY OF WATERLOO, Canada	</td></tr>
                         <tr className="font-normal"><td>21	</td><td>HARSH VOHRA	</td><td>	DEAKIN UNIVERSITY, Australia	</td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )
              }
              {yearSelection === "2" && (
                <div class="advertisementspress advertisementsyr2023" >
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE NATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-1.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">BHAKTI BANSAL</p>
                          <p>IIT,BOMBAY</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-2.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SUCHIT SRIVASTAVA</p>
                          <p>IIT,HYDERABAD</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-3.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SADHIL ARORA</p>
                          <p>NATIONAL LAW UNIVERSITY </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-4.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">DHRUV MEHTA</p>
                          <p>NETAJI SUBHASH UNIVERSITY OF TECHNOLOGY (NSUT)</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-5.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">AKSHAT PUNDHIR</p>
                          <p>BITS PILANI</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-6.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">TRISHA SAXENA </p>
                          <p>THE WEST BENGAL NATIONAL UNIVERSITY OF JURIDICAL SCIENCES</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ANUSHKA-RATHORE6125.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ANUSHKA RATHORE</p>
                          <p>All India Institute of Medical Science, Gorakhpur </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th> S.No.</th>
                        <th>LEARNER'S&nbsp; NAME&nbsp;</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>BHAKTI BANSAL</td>
                          <td>IIT,BOMBAY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>SUCHIT SRIVASTAVA</td>
                          <td>IIT,HYDERABAD</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>SADHIL ARORA</td>
                          <td>NATIONAL LAW UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>HIYA JAIN</td>
                          <td>ST STEPHENS COLLEGE,DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>PREKSHA BOHRA</td>
                          <td>LSR(LADY SRI RAM SCHOOL),DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>ANUSHKA RATHORE</td>
                          <td>All India Institute of Medical Science, Gorakhpur </td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>TARUSH CHAUDHARY</td>
                          <td>SRCC,DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>8</td>
                          <td>ROHINI VERMA</td>
                          <td>KASTURBA MEDICAL COLLEGE, MANGALORE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>9</td>
                          <td>RISHITA SINGH</td>
                          <td>SRCC,DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>10</td>
                          <td>SHIKHER AGRAWAL</td>
                          <td>SRI GURU GOBIND SINGH COLLEGE OF COMMERCE,DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>11</td>
                          <td>DHRUV MEHTA</td>
                          <td>NETAJI SUBHASH UNIVERSITY OF TECHNOLOGY (NSUT)</td>
                        </tr>
                        <tr className="font-normal">
                          <td>12</td>
                          <td>MANYA DHULL</td>
                          <td>ARYABHATTA COLLEGE - SOUTH CAMPUS,DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>13</td>
                          <td>ROYCE KAPOOR</td>
                          <td>DRONACHARYA COLLEGE OF ENGINEERING,HARYANA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>14</td>
                          <td>MIHEEKA BHASIN</td>
                          <td>FLAME UNIVERSITY, PUNE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>15</td>
                          <td>ADVAY AWASTHY</td>
                          <td>ASHOKA UNIVERSITY,SONIPAT, SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>16</td>
                          <td>ANANYAA PRIYA NAIR</td>
                          <td>FLAME UNIVERSITY, PUNE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>17</td>
                          <td>AKSHAT PUNDHIR</td>
                          <td>BITS PILANI</td>
                        </tr>
                        <tr className="font-normal">
                          <td>18</td>
                          <td>AVIRAL SONI</td>
                          <td>BITS PILANI DUBAI CAMPUS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>19</td>
                          <td>DIVYANSHI DIWAN</td>
                          <td>VELLORE INSTITUTE OF TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>20</td>
                          <td>NAVYA GOSAIN</td>
                          <td>DAULAT RAM COLLEGE NORTH CAMPUS,DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>21</td>
                          <td>GARV NAGPAL</td>
                          <td>SHAHEED BHAGAT SINGH COLLEGE,DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>22</td>
                          <td>PRATHAM LAL</td>
                          <td>VIT, VELLORE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>23</td>
                          <td>TRISHA SAXENA</td>
                          <td>THE WEST BENGAL NATIONAL UNIVERSITY OF JURIDICAL SCIENCES</td>
                        </tr>
                        <tr className="font-normal">
                          <td>24</td>
                          <td>ISHITA BHUSHAN</td>
                          <td>ASHOKA UNIVERSITY,SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>25</td>
                          <td>MEENAL GOEL</td>
                          <td>ASHOKA UNIVERSITY,SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>26</td>
                          <td>KIAH SINGHAL</td>
                          <td>ASHOKA UNIVERSITY,SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>27</td>
                          <td>CHERYL JOSHI</td>
                          <td>ASHOKA UNIVERSITY,SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>28</td>
                          <td>SHAURYA MUKHERJI</td>
                          <td>O.P JINDAL GLOBAL UNIVERSITY ,SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>29</td>
                          <td>KRISHA RASTOGI</td>
                          <td>O.P JINDAL GLOBAL UNIVERSITY ,SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>30</td>
                          <td>ARYAN BHASKER</td>
                          <td>CHRIST UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>31</td>
                          <td>MITARTH SAXENA</td>
                          <td>O. P. JINDAL GLOBAL UNIVERSITY,SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>32</td>
                          <td>KISHA DUA</td>
                          <td>MAHARASHTRA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>33</td>
                          <td>ALIZA ALAM</td>
                          <td>NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES,MAHARASHTRA- BBA - MUMBAI MAIN CAMPUS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>34</td>
                          <td>ARSHIA KATOCH</td>
                          <td>NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES,MAHARASHTRA- BBA - MUMBAI MAIN CAMPUS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>35</td>
                          <td>BHAVYA DHINGRA</td>
                          <td>MANIPAL UNIVERSITY,JAIPUR</td>
                        </tr>
                        <tr className="font-normal">
                          <td>36</td>
                          <td>ANGEL THAKUR</td>
                          <td>SHIV NADAR INSTITUTE OF EMMINENCE,SHIV NADAR SCHOOL OF NATURAL SCIENCES,UP</td>
                        </tr>
                        <tr className="font-normal">
                          <td>37</td>
                          <td>ABHIRUDER SOLANKI</td>
                          <td>THAPAR INSTITUTE OF ENGINEERING AND TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>38</td>
                          <td>GARVIT KHATRI</td>
                          <td>NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES,MAHARASHTRA BENGALURU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>39</td>
                          <td>YASH BAISHYA</td>
                          <td>JAYPEE INSTITUTE OF INFORMATION TECHNOLOGY, NOIDA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>40</td>
                          <td>MAHI MAHAJAN</td>
                          <td>SRM,CHENNAI</td>
                        </tr>
                        <tr className="font-normal">
                          <td>41</td>
                          <td>OM MISHRA</td>
                          <td>UNIVERSITY OF PETROLEUM AND ENERGY STUDIES(UPES),DEHRADUN</td>
                        </tr>
                        <tr className="font-normal">
                          <td>42</td>
                          <td>SHWETA GANESH</td>
                          <td>MANIPAL ACADEMY OF HIGHER EDUCATION,KARNATAKA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>43</td>
                          <td>DIYA SANDHIR</td>
                          <td>ASHOKA UNIVERSITY,SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>44</td>
                          <td>DEVASYA KANWAR</td>
                          <td>THAPAR UNIVERSITY,PATIALA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>45</td>
                          <td>MAHAK DUTTA</td>
                          <td>ASHOKA UNIVERSITY,SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>46</td>
                          <td>DIVIJ PUNANI</td>
                          <td>NARSEE MONJEE INSTITUTE MANAGEMENT STIDIES,MAHARASHTRA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>47</td>
                          <td>ARYAN KAPOOR</td>
                          <td>OP JINDAL GLOBAL UNIVERSITY,HARYANA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>48</td>
                          <td>SUHANI DEEPAK AGRAWAT</td>
                          <td>SHIV NADAR INSTITUTE OF EMINENCE DEEMED TO BE UNIVERSITY,UP</td>
                        </tr>
                        <tr className="font-normal">
                          <td>49</td>
                          <td>RAKSHITH PERTHI</td>
                          <td>IILM UNIVERSITY,GURGAON</td>
                        </tr>
                        <tr className="font-normal">
                          <td>50</td>
                          <td>AANYA SINGH</td>
                          <td>MASTERS UNION,HARYANA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>51</td>
                          <td>AAKSHAT MISHRA</td>
                          <td>NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES,MAHARASHTRA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>52</td>
                          <td>KHUSHI BHUTANI</td>
                          <td>NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES</td>
                        </tr>
                        <tr className="font-normal">
                          <td>53</td>
                          <td>SIDDH JAIN</td>
                          <td>NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES</td>
                        </tr>
                        <tr className="font-normal">
                          <td>54</td>
                          <td>SUNAINA CHAUHAN DUTTA</td>
                          <td>O.P JINDAL GLOBAL UNIVERSITY ,SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>55</td>
                          <td>ATIN GUPTA</td>
                          <td>THAPAR UNIVERSITY,PATIALA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>56</td>
                          <td>PRANSHU KAUSHIK</td>
                          <td>SRM,CHENNAI</td>
                        </tr>
                        <tr className="font-normal">
                          <td>57</td>
                          <td>BHAVYA JAIN</td>
                          <td>PLAKSHA UNIVERSITY,CHANDIGARH</td>
                        </tr>
                        <tr className="font-normal">
                          <td>58</td>
                          <td>MANAS KUMARIA</td>
                          <td>O.P. JINDAL GLOBAL UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>59</td>
                          <td>PRATHAM CHAWLA</td>
                          <td>PEARL ACADEMY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>60</td>
                          <td>HARSH JOSHI</td>
                          <td>THAPAR UNIVERSITY,PATIALA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>61</td>
                          <td>KARMANYAA SANKHE</td>
                          <td>WOXEN UNIVERSITY, WOXSEN SCHOOL OF LIBERAL ARTS AND HUMANITIES, HYDERABAD</td>
                        </tr>
                        <tr className="font-normal">
                          <td>62</td>
                          <td>SHIKHAR BANSAL</td>
                          <td>AMITY UNIVERSITY,NOIDA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>63</td>
                          <td>AGASTYA YADAV</td>
                          <td>O.P. JINDAL GLOBAL UNIVERSITY,SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>64</td>
                          <td>UJJAINI DEY</td>
                          <td>IILM UNIVERSITY,GURUGRAM</td>
                        </tr>
                        <tr className="font-normal">
                          <td>65</td>
                          <td>ISHITTA MADHYAN</td>
                          <td>INDIAN SCHOOL OH HOSPITALITY ,GURUGRAM</td>
                        </tr>
                        <tr className="font-normal">
                          <td>66</td>
                          <td>PRISHA ALAWADI</td>
                          <td>OP JINDAL GLOBAL UNIVERSITY,SONIPAT</td>
                        </tr>

                      </tbody></table>
                  </div>
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE INTERNATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-7.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">AANYA MARWAHA</p>
                          <p>UNIVERSITY OF ILLINOIS, URBANA CHAMPAIGN</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-8.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">DEVANSH GUPTA </p>
                          <p>UNIVERSITY OF MELBOURNE PARKVILLE,AUSTRALIA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-9.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">HARJAS KAUR</p>
                          <p>UNIVERSITY OF ILLINOIS, URBANA-CHAMPAIGN ,USA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-10.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">JIA ARORA</p>
                          <p>UNIVERSITY OF NEW SOUTH WHALES,SYDNEY,AUSTRALIA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-11.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">PAVNI GUPTA</p>
                          <p>UNIVERSITY OF MELBOURNE,AUSTRALIA </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-12.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">PRISHA SOOD</p>
                          <p>NATIONAL UNIVERSITY OF SINGAPORE</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-13.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">RISHITA SINGH </p>
                          <p>UNIVERSITY OF WARWICK,UK</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th>S.No.</th>
                        <th>LEARNER’S&nbsp; NAME&nbsp;</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>AANYA MARWAHA</td>
                          <td>UNIVERSITY OF ILLINOIS, URBANA CHAMPAIGN</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>AARYAMAN BISHT</td>
                          <td>MICHIGAN STATE UNIVERSITY,USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>AASHMAN DULLOO</td>
                          <td>MANIPAL ACADEMY OF HIGHER EDUCATION,DUBAI</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>ABHIGYAN SRIVASTAVA</td>
                          <td>UNIVERSITY OF WATERLOO,CANADA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>ARYAN DHINGRA</td>
                          <td>DEAKIN UNIVERSITY, AUSTRALIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>DEVANSH GUPTA</td>
                          <td>UNIVERSITY OF MELBOURNE PARKVILLE,AUSTRALIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>EKUS SINGH KHOSLA</td>
                          <td>HURON AT WESTERN UNIVERSITY,ONTARIO</td>
                        </tr>
                        <tr className="font-normal">
                          <td>8</td>
                          <td>GAURIKA SINGH</td>
                          <td>PENNSYLVANIA STATE UNIVERSITY, USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>9</td>
                          <td>HARJAS KAUR</td>
                          <td>UNIVERSITY OF ILLINOIS, URBANA-CHAMPAIGN ,USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>10</td>
                          <td>JIA ARORA</td>
                          <td>UNIVERSITY OF NEW SOUTH WHALES,SYDNEY,AUSTRALIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>11</td>
                          <td>MEDHANSH DHAWAN</td>
                          <td>SUNRISE AVIATION FLIGHT SCHOOL,FLORIDA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>12</td>
                          <td>NAVYYA MAKIN</td>
                          <td>LANCERIA FLIGHT CENTRE,JOHANNESBURG</td>
                        </tr>
                        <tr className="font-normal">
                          <td>13</td>
                          <td>NEDA KAPOOR</td>
                          <td>ESSEC BUSINESS SCHOOL, SINGAPORE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>14</td>
                          <td>OORJA SOOD</td>
                          <td>UNIVERSITY OF ARTS LONDON,LONDON COLLEGE OF FASHION</td>
                        </tr>
                        <tr className="font-normal">
                          <td>15</td>
                          <td>PAVNI GUPTA</td>
                          <td>UNIVERSITY OF MELBOURNE,AUSTRALIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>16</td>
                          <td>PRATYUSH MUGRAI</td>
                          <td>UNIVERSITY OF ALBERTA,CANADA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>17</td>
                          <td>PRISHA SOOD</td>
                          <td>NATIONAL UNIVERSITY OF SINGAPORE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>18</td>
                          <td>RISHITA SINGH</td>
                          <td>UNIVERSITY OF WARWICK,UK</td>
                        </tr>
                        <tr className="font-normal">
                          <td>19</td>
                          <td>SHIRIN MISRA</td>
                          <td>AMERICAN UNIVERSITY OF ANTIGUA, OSBOURN,BARBUDA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>20</td>
                          <td>SHIVAAN SAWHNEY</td>
                          <td>NORTHEASTERN UNIVERSITY ,BOSTON</td>
                        </tr>
                        <tr className="font-normal">
                          <td>21</td>
                          <td>SHREYA MAJUMBER</td>
                          <td>UNION COLLEGE,USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>22</td>
                          <td>SMIRA CHANAN</td>
                          <td>QUEEN'S UNIVERSITY,UK</td>
                        </tr>
                        <tr className="font-normal">
                          <td>23</td>
                          <td>TANUL GUPTA</td>
                          <td>VIRGINIA TECH ENGINEERING COLLEGE,USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>24</td>
                          <td>TVARITA GAUR</td>
                          <td>ARIZONA STATE UNIVERSITY,USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>25</td>
                          <td>VANSHIKA KAPOOR</td>
                          <td>DURHAM UNIVERSITY,UK</td>
                        </tr>
                        <tr className="font-normal">
                          <td>26</td>
                          <td>VEDANT AGARWAL</td>
                          <td>PENNSYLVANIA STATE UNIVERSITY, USA</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {yearSelection === "3" && (
                <div class="">
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE NATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-2021-1.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">INHAAS VIRMANI</p>
                          <p>IIT DELHI</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-2021-2.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SIDDHARTH MISHRA </p>
                          <p>IIT MADRAS</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-2021-3.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ABHAY VERMA </p>
                          <p>NIT TIRUICHIRAPALLI </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-2021-4.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">NIPUN YADAV </p>
                          <p>BITS PILANI</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-2021-5.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">MANBHAV SUGLA </p>
                          <p>BITS PILANI</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-2021-6.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">VIKRAMADITYA YADAV </p>
                          <p>KING EDWARD MEMORIAL HOSPITAL &amp; SETH GORDHANDAS SUNDERDAS MEDICAL COLLEGE ,MUMBAI</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th> S.No.</th>
                        <th>LEARNER'S&nbsp; NAME&nbsp;</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>ABHAY VERMA</td>
                          <td>NIT Tiruichirapalli , Madras</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>ADITYA TETERVE</td>
                          <td>MIT SIKKIM, Manipal University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>ANINDYA MISHRA</td>
                          <td>MANIPAL UNIVERSITY JAIPUR</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>ARCHIT CHOPRA</td>
                          <td>MANIPAL UNIVERSITY JAIPUR</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>ARNAV GARG</td>
                          <td>MANIPAL INSTITUTE OF TECHNOLOGY, MANIPAL</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>DHANUR CHAHAL</td>
                          <td>GURU GOBIND SINGH , IP University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>DIVIJ BHAMBHANI</td>
                          <td>VELLORE INSTITUTE OF TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>8</td>
                          <td>DIYA TRIPATHI</td>
                          <td>ASHOKA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>9</td>
                          <td>ESHAAN ARYAN SINHA</td>
                          <td>MIT MANIPAL</td>
                        </tr>
                        <tr className="font-normal">
                          <td>10</td>
                          <td>INHAAS VIRMANI</td>
                          <td>IIT DELHI</td>
                        </tr>
                        <tr className="font-normal">
                          <td>11</td>
                          <td>ISHAAN KONWAR SAIKIA</td>
                          <td>MANIPAL UNIVERSITY JAIPUR</td>
                        </tr>
                        <tr className="font-normal">
                          <td>12</td>
                          <td>ISHAAN VATUS</td>
                          <td>MIT MANIPAL</td>
                        </tr>
                        <tr className="font-normal">
                          <td>13</td>
                          <td>KRISHANG KILLA</td>
                          <td>SRM UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>14</td>
                          <td>NIPUN YADAV</td>
                          <td>BITS , Pillani</td>
                        </tr>
                        <tr className="font-normal">
                          <td>15</td>
                          <td>PRANAY GOEL</td>
                          <td>MIT, MANIPAL</td>
                        </tr>
                        <tr className="font-normal">
                          <td>16</td>
                          <td>SAKSHAM GUPTA</td>
                          <td>MANIPAL UNIVERSITY JAIPUR ,</td>
                        </tr>
                        <tr className="font-normal">
                          <td>17</td>
                          <td>SHEEN NAGRI</td>
                          <td>JAMIA MILIA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>18</td>
                          <td>SIDDHARTH MISHRA</td>
                          <td>IIT MADRAS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>19</td>
                          <td>TANUSH YADAV</td>
                          <td>MANIPAL UNIVERSITY JAIPUR</td>
                        </tr>
                        <tr className="font-normal">
                          <td>20</td>
                          <td>VIDIT YADUVANSHI</td>
                          <td>MANIPAL UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>21</td>
                          <td>ASVIKA NIGAM</td>
                          <td>SHIV NADAR UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>22</td>
                          <td>BHASKAR YADAV</td>
                          <td>G.D. GOENKA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>23</td>
                          <td>DIVANSHIE SUMIT SETIA</td>
                          <td>THAPAR INSTITUTE OF ENGINEERING AND TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>24</td>
                          <td>ISHIKA ARORA</td>
                          <td>SYMBIOSIS INSTITUTE OF HEALTH SCIENCES</td>
                        </tr>
                        <tr className="font-normal">
                          <td>25</td>
                          <td>KAVYA SONDHI</td>
                          <td>Ashoka University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>26</td>
                          <td>KHYATI PRASAD</td>
                          <td>TEERTHANKER MAHAVEER MEDICAL COLLEGE,TEERTHANKER MAHAVEER UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>27</td>
                          <td>MANBHAV SUGLA</td>
                          <td>BITS PILANI, Goa Campus</td>
                        </tr>
                        <tr className="font-normal">
                          <td>28</td>
                          <td>NISHA BARBUDDHE</td>
                          <td>NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES</td>
                        </tr>
                        <tr className="font-normal">
                          <td>29</td>
                          <td>RAJ KASERA</td>
                          <td>AMITY University , NOIDA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>30</td>
                          <td>SPARSH GUPTA</td>
                          <td>MANIPAL INSTITUTE OF TECHNOLOGY, UDUPI</td>
                        </tr>
                        <tr className="font-normal">
                          <td>31</td>
                          <td>SUHANI VALECHA</td>
                          <td>MANIPAL UNIVERSITY JAIPUR</td>
                        </tr>
                        <tr className="font-normal">
                          <td>32</td>
                          <td>TITHI SARKAR</td>
                          <td>JK BUSINESS SCHOOL, Gurugram University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>33</td>
                          <td>VANSHIKA SINGH</td>
                          <td>ST. XAVIER'S COLLEGE, Gujrat University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>34</td>
                          <td>VIKRAMADITYA YADAV</td>
                          <td>KING EDWARD MEMORIAL HOSPITAL AND SETH GORDHANDAS SUNDERDAS MEDICAL COLLEGE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>35</td>
                          <td>ADRIJA DE</td>
                          <td>KREA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>36</td>
                          <td>ANNAHITA RATHI</td>
                          <td>JINDAL SCHOOL OF BANKING AND FINANCE , JINDAL UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>37</td>
                          <td>INDERJIT SINGH</td>
                          <td>SYMBIOSIS SCHOOL OF ECONOMICS , PUNE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>38</td>
                          <td>MANAN DUTTA</td>
                          <td>SYMBIOSIS CENTRE FOR MANAGEMENT STUDIES</td>
                        </tr>
                        <tr className="font-normal">
                          <td>39</td>
                          <td>MANAS JAIN</td>
                          <td>SRISHTI INSTITUTE OF ART AND DESIGN, SRISHTI MAHE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>40</td>
                          <td>RISSA DATTA</td>
                          <td>PRAVIN DALAL SCHOOL OF ENTREPRENEURSHIP AND FAMILY BUSINESS MANAGEMENT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>41</td>
                          <td>Tiya Gupta</td>
                          <td>DAULAT RAM COLLEGE (W), DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>42</td>
                          <td>YASHIKA GUPTA</td>
                          <td>GD GOENKA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>43</td>
                          <td>SAAGARIKA GAHLOT</td>
                          <td>Maitreyi College , DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>44</td>
                          <td>RIDDHI MAHESHWARI</td>
                          <td>NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES</td>
                        </tr>
                        <tr className="font-normal">
                          <td>45</td>
                          <td>Dhriti Agarwal</td>
                          <td>NMIMS BENGALURU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>46</td>
                          <td>SARMATHA RADHAKRISHNAN</td>
                          <td>MAITREYI COLLEGE , DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>47</td>
                          <td>ADITYA VERMA</td>
                          <td>OP JINDAL GLOBAL UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>48</td>
                          <td>ARYAN KUMAR</td>
                          <td>JINDAL GLOBAL BUSINESS SCHOOL</td>
                        </tr>
                        <tr className="font-normal">
                          <td>49</td>
                          <td>HRIDAY GULATI</td>
                          <td>Anil Surendra Modi School of Commerce, NMIMS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>50</td>
                          <td>IRA KHER</td>
                          <td>MIT INSTITUTE OF DESIGN, MIT-ADT UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>51</td>
                          <td>Ishaan Gupta</td>
                          <td>KIRORI MAL,Delhi University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>52</td>
                          <td>JALAJ YADAV</td>
                          <td>SHAHEED SUKHDEV COLLEGE OF BUSINESS STUDIES ,DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>53</td>
                          <td>LORD LUGANI</td>
                          <td>NARSEE MONJEE COLLEGE OF COMMERCE AND ECONOMICS, Mumbai University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>54</td>
                          <td>Lovish Choudhary</td>
                          <td>SAMSOE , NIMIMS MUMBAI</td>
                        </tr>
                        <tr className="font-normal">
                          <td>55</td>
                          <td>Palak kabra</td>
                          <td>CHRIST UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>56</td>
                          <td>PANSHUL JETWANI</td>
                          <td>ARYABHATTA, DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>57</td>
                          <td>PRATYUSH PURWAR</td>
                          <td>SRI VENKATESHWARA COLLEGE, DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>58</td>
                          <td>RISHAB JAIN</td>
                          <td>Anil Surendra Modi School of Commerce, NMIMS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>59</td>
                          <td>ROLI AGGARWAL</td>
                          <td>SHAHEED SUKHDEV COLLEGE OF BUSINESS STUDIES, DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>60</td>
                          <td>Sachit Gupta</td>
                          <td>NEW DELHI INSTITUTE OF MANAGEMENT , IP UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>61</td>
                          <td>Sarisha Jaggi</td>
                          <td>NMIMS's SARLA ANIL MODI SCHOOL OF ECONOMICS,NMIMS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>62</td>
                          <td>STUTI SINGHAL</td>
                          <td>NARSEE MONJEE COLLEGE OF COMMERCE AND ECONOMICS, Mumbai University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>63</td>
                          <td>PRERNA SEJWAL</td>
                          <td>SYMBIOSIS CENTRE OF MANAGEMENT STUDIES</td>
                        </tr>
                        <tr className="font-normal">
                          <td>64</td>
                          <td>RIYA KUMAR</td>
                          <td>NARSEE MONJEE COLLEGE OF COMMERCE AND ECONOMICS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>65</td>
                          <td>ANUSHKA BANSAL</td>
                          <td>SYMBIOSIS LAW SCHOOL</td>
                        </tr>
                        <tr className="font-normal">
                          <td>66</td>
                          <td>ARUSHI BANERJEE</td>
                          <td>SYMBIOSIS SCHOOL OF ECONOMICS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>67</td>
                          <td>KAVYA</td>
                          <td>NIFT KANGRA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>68</td>
                          <td>MAANYAA GUPTA</td>
                          <td>JINDAL GLOBAL LAW SCHOOL, SONEPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>69</td>
                          <td>MEGHA BISHT</td>
                          <td>JESUS AND MARY , DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>70</td>
                          <td>Mehak Chawla</td>
                          <td>OP JINDAL GLOBAL UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>71</td>
                          <td>MEHMA SINGH AHLUWALIA</td>
                          <td>PEARL ACADEMY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>72</td>
                          <td>MIHIR SHYAM</td>
                          <td>GD GOENKA UNIVERSITY GURGAON</td>
                        </tr>
                        <tr className="font-normal">
                          <td>73</td>
                          <td>PARTH PIYUSH PRASAD</td>
                          <td>FLAME UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>74</td>
                          <td>RIYA KUMAR</td>
                          <td>NATIONAL INSTITUTE OF FASHION TECHNOLOGY, DELHI</td>
                        </tr>
                        <tr className="font-normal">
                          <td>75</td>
                          <td>ROHAN MENDIRATTA</td>
                          <td>JINDAL SCHOOL OF PSYCHOLOGY AND COUNSELING</td>
                        </tr>
                        <tr className="font-normal">
                          <td>76</td>
                          <td>SAMYAK YASH JAIN</td>
                          <td>MANIPAL INSTITUTE OF COMMUNICATION</td>
                        </tr>
                        <tr className="font-normal">
                          <td>77</td>
                          <td>TAMANNA NAGPAL</td>
                          <td>SUSHANT UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>78</td>
                          <td>YUVRAJ MANN</td>
                          <td>NARSEE MONJEE (NMIMS)</td>
                        </tr>
                        <tr className="font-normal">
                          <td>79</td>
                          <td>AARUSHI DHAWAN</td>
                          <td>AMITY, NOIDA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>80</td>
                          <td>MAANYA GUPTA</td>
                          <td>JINDAL GLOBAL LAW SCHOOL</td>
                        </tr>
                      </tbody></table>
                  </div>
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE INTERNATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-7.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">AVISHI MONGA</p>
                          <p>UNIVERSITY OF OXFORD </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-8.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">AMITESH ANAND PANDEY </p>
                          <p>CALTECH , CALIFORNIA INSTITUTE TECHNOLOGY </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-9.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">KHUSHI SATNALIWALA </p>
                          <p>IMPERIAL COLLEGE LONDON </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-10.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ARUNAKSH KAPOOR</p>
                          <p>NANYANG TECHNOLOGICAL UNIVERSITY, SINGAPORE </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-11.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">KHUSHI SOOD </p>
                          <p>UNIVERSITY OF SINGAPORE </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/almin-12.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ANANYA JAIN</p>
                          <p>GEORGIA INSTITUTE OF TECHNOLOGY ,USA</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th> S.No.</th>
                        <th>LEARNER’S&nbsp; NAME&nbsp;</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>AMITESH ANAND PANDEY</td>
                          <td>CALIFORNIA INSTITUTE TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>ANANYA JAIN</td>
                          <td>GEORGIA INSTITUTE OF TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>ARCHIT SHARMA</td>
                          <td>University of Wisconsin-Madison , USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>ARUNAKSH KAPOOR</td>
                          <td>NANYANG TECHNOLOGICAL UNIVERSITY, SINGAPORE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>MADHAV PRATAP SINGH</td>
                          <td>TECHNICAL UNIVERSITY OF EINDHOVEN</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>NIHAL KALER</td>
                          <td>UNIVERSITY OF AUCKLAND , New Zealand</td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>RIYA RAWAL</td>
                          <td>PENSTATE, USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>8</td>
                          <td>RIYA SUHAG</td>
                          <td>RUTGERS UNIVERSITY-NEW BRUNSWICK , USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>9</td>
                          <td>ANAND KRIPAL AGGARWAL</td>
                          <td>UNIVERSITY OF SYDNEY , Australia</td>
                        </tr>
                        <tr className="font-normal">
                          <td>10</td>
                          <td>AVISHI MONGA</td>
                          <td>UNIVERSITY OF OXFORD, United Kingdom</td>
                        </tr>
                        <tr className="font-normal">
                          <td>11</td>
                          <td>FREYA SIDHWA</td>
                          <td>NEW YORK UNIVERSITY ,USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>12</td>
                          <td>JIVESH MEHTA</td>
                          <td>UNIVERSITY OF WISCONSIN-MADISON, USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>13</td>
                          <td>KHUSHI SATNALIWALA</td>
                          <td>IMPERIAL COLLEGE LONDON</td>
                        </tr>
                        <tr className="font-normal">
                          <td>14</td>
                          <td>PRARABDHA HALDER</td>
                          <td>PENN STATE , USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>15</td>
                          <td>SRISHTI MAKKAR</td>
                          <td>RADBOUND UNIVERSITY, NETHERLANDS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>16</td>
                          <td>AADITYA KUMAR</td>
                          <td>UNIVERSITY OF TORONTO, CANADA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>17</td>
                          <td>ANIRUDH RATHOD</td>
                          <td>ERASAMUS UNIVERSITY ROTTERDAM,NETHERLANDS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>18</td>
                          <td>GAYATRI VARMA</td>
                          <td>UNIVERSITY OF TORONTO, ST. GEORGE CAMPUS , CANADA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>19</td>
                          <td>SARAH MAHESHWARI</td>
                          <td>TRINITY COLLEGE DUBLIN ,IRELAND</td>
                        </tr>
                        <tr className="font-normal">
                          <td>20</td>
                          <td>SIYA KHATTAR</td>
                          <td>MONASH UNIVERSITY , AUSTRALIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>21</td>
                          <td>ARJUN POONIA</td>
                          <td>DEAKIN UNIVERSITY, AUSTRALIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>22</td>
                          <td>AGASTYA SHARMA</td>
                          <td>EMILY CARR UNIVERSITY OF ART AND DESIGN , CANADA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>23</td>
                          <td>DIVYAA SHARMA</td>
                          <td>UNIVERSITY OF READING , UNITED KINGDOM</td>
                        </tr>
                        <tr className="font-normal">
                          <td>24</td>
                          <td>GAURANGI OBEROI</td>
                          <td>UNIVERSITY OF BRITISH COLUMBIA , CANADA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>25</td>
                          <td>KHUSHI SOOD</td>
                          <td>UNIVERSITY OF SINGAPORE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>26</td>
                          <td>TANVI CHAND</td>
                          <td>PURDUE UNIVERSITY, USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>27</td>
                          <td>MAYANK KATARIA</td>
                          <td>SAUDER SCHOOL OF BUSINESS,UNIVERSITY OF BRITISH COLUMBIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>28</td>
                          <td>NANDINI SINGH</td>
                          <td>FASHION INSTITUTE OF TECHNOLOGY , STATE UNIVERSITY OF NEW YORK</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {yearSelection === "4" && (
                <div class="">
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE NATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ARYAN-BAJAJ.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ARYAN BAJAJ</p>
                          <p>IIT, Banaras Hindu University</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/KSHITIJ-KAUL.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">KSHITIJ KAUL</p>
                          <p>SRI RAM COLLEGE OF COMMERCE</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/RADHIKAA-GOEL.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">RADHIKAA GOEL </p>
                          <p>DELHI UNIVERSITY</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/YOGITA-BAISHYA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">YOGITA BAISHYA</p>
                          <p>ASHOKA UNIVERSITY</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/DIVYAKSHI-SINGH.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">DIVYAKSHI SINGH</p>
                          <p>ASHOKA UNIVERSITY SONIPAT</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th> S.No.</th>
                        <th>LEARNER'S&nbsp; NAME&nbsp;</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>ARYAN BAJAJ</td>
                          <td>IIT, Banaras Hindu University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>KSHITIJ KAUL</td>
                          <td>SRI RAM COLLEGE OF COMMERCE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>RADHIKAA GOEL</td>
                          <td>DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>YOGITA BAISHYA</td>
                          <td>ASHOKA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>DIVYAKSHI SINGH</td>
                          <td>ASHOKA UNIVERSITY SONIPAT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>SHAURYA BABBAR</td>
                          <td>SRISHTI INSTITUTE OF ART, DESIGN AND TECHNOLOGY, BENGALURU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>VANI GUGNANI</td>
                          <td>SRISHTI INSTITUTE OF ART, DESIGN AND TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>8</td>
                          <td>AAHANA NATH</td>
                          <td>KIIT( KALINGA INSTITUTE OF INDUSTRIAL TECHNOLOGY)</td>
                        </tr>
                        <tr className="font-normal">
                          <td>9</td>
                          <td>ANANYA SINGH</td>
                          <td>VELLORE INSTITUTE OF TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>10</td>
                          <td>ANJALI RAJ PATHAK</td>
                          <td>VELLORE INSTITUTE OF TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>11</td>
                          <td>NAINIKA GUPTA</td>
                          <td>PLAKSHA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>12</td>
                          <td>PRISHA RAI</td>
                          <td>JAYPEE INSTITUTE OF INFORMATION TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>13</td>
                          <td>RITISHA ARORA</td>
                          <td>VELLORE INSTITUTE OF TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>14</td>
                          <td>SAKSHAM AGARWAL</td>
                          <td>KALINGA INSTITUTE OF INDUSTRIAL TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>15</td>
                          <td>SEEMANTINI RAY</td>
                          <td>SHIV NADAR UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>16</td>
                          <td>PRATYUSH JOSHI</td>
                          <td>SHIV NADAR UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>17</td>
                          <td>SARTHAK NARANG</td>
                          <td>TOLANI, PUNE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>18</td>
                          <td>SHASHWAT SHARMA</td>
                          <td>NIIT UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>19</td>
                          <td>SHIVANSH SHARMA</td>
                          <td>MANIPAL MAIN BRANCH</td>
                        </tr>
                        <tr className="font-normal">
                          <td>20</td>
                          <td>SIA SINGH</td>
                          <td>MANIPAL BRANCH</td>
                        </tr>
                        <tr className="font-normal">
                          <td>21</td>
                          <td>TEJAS MISHRA</td>
                          <td>MANIPAL INSTITUTE OF TECH.</td>
                        </tr>
                        <tr className="font-normal">
                          <td>22</td>
                          <td>ANSHUL RANA</td>
                          <td>PLAKSHA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>23</td>
                          <td>AARYAN PERIWAL</td>
                          <td>NARSEE MONJEE INSITUTE OF MANAGEMENT STUDIES</td>
                        </tr>
                        <tr className="font-normal">
                          <td>24</td>
                          <td>ABEER CHOPRA</td>
                          <td>SUSHANT UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>25</td>
                          <td>ANSH CHAWLA</td>
                          <td>MANIPAL UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>26</td>
                          <td>JAANSHI KIRAN</td>
                          <td>SYMBIOSIS SCHOOL OF ECONOMICS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>27</td>
                          <td>KSHITIJ KAUL</td>
                          <td>SRI RAM COLLEGE OF COMMERCE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>28</td>
                          <td>LAVYA THAKAR</td>
                          <td>CHRIST UNIVERSITY CENTRAL CAMPUS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>29</td>
                          <td>SAKSHAM SINGHAL</td>
                          <td>SYMBIOSIS</td>
                        </tr>
                        <tr className="font-normal">
                          <td>30</td>
                          <td>SHAURYA BAJAJ</td>
                          <td>THE NORTH CAP UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>31</td>
                          <td>SYNA JAIN</td>
                          <td>UNITEDWORLD INSTITUTE OF DESIGN (UID), KARNAVATI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>32</td>
                          <td>YUVRAJ KAPOOR</td>
                          <td>SVKM'S NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES</td>
                        </tr>
                        <tr className="font-normal">
                          <td>33</td>
                          <td>AGASSTYA P KHANNA</td>
                          <td>SHIV NADAR</td>
                        </tr>
                        <tr className="font-normal">
                          <td>34</td>
                          <td>ANOUSHKA MATHUR</td>
                          <td>SONEPAT UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>35</td>
                          <td>BHAVYA KAPOOR</td>
                          <td>MAHARASHTRA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>36</td>
                          <td>DEV GUPTA</td>
                          <td>INDIAN SCHOOL OF HOSPITALITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>37</td>
                          <td>KANAY NARANG</td>
                          <td>NARSEE MONJEE INSITUTE OF MANAGEMENT STUDIES</td>
                        </tr>
                        <tr className="font-normal">
                          <td>38</td>
                          <td>KRRISH GUPTA</td>
                          <td>OP JINDAL</td>
                        </tr>
                        <tr className="font-normal">
                          <td>39</td>
                          <td>RADHIKAA GOEL</td>
                          <td>DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>40</td>
                          <td>SABRINA SINGH</td>
                          <td>GURGAON</td>
                        </tr>
                        <tr className="font-normal">
                          <td>41</td>
                          <td>SAUMYAA VIRMANI</td>
                          <td>CHRIST UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>42</td>
                          <td>SUBHIKSHA.R</td>
                          <td>CHRIST UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>43</td>
                          <td>T SHREYA</td>
                          <td>DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>44</td>
                          <td>TANVI ARORA</td>
                          <td>DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>45</td>
                          <td>TRUPTI AGARWAL</td>
                          <td>GD GOENKA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>46</td>
                          <td>YOGITA BAISHYA</td>
                          <td>ASHOKA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>47</td>
                          <td>T SHREYA</td>
                          <td>DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>48</td>
                          <td>TANVI ARORA</td>
                          <td>DELHI UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>49</td>
                          <td>SHAGUN BOHRA</td>
                          <td>SP JAIN SCHOOL OF GLOBAL MANAGEMENT</td>
                        </tr>
                        <tr className="font-normal">
                          <td>50</td>
                          <td>OOSHMA ARORA</td>
                          <td>DEN DAYAL UPADHYAYA COLLEGE (UNIVERSITY OF DELHI)</td>
                        </tr>
                        <tr className="font-normal">
                          <td>51</td>
                          <td>AARUSHI KHETERPAL</td>
                          <td>SYMBIOSIS SCHOOL OF LIBERAL ARTS PUNE</td>
                        </tr>
                        <tr className="font-normal">
                          <td>52</td>
                          <td>ARYAN JAIN</td>
                          <td>WBNUJS,KOLKATA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>53</td>
                          <td>POORVI NASA</td>
                          <td>MANIPAL UNIVERSITY JAIPUR</td>
                        </tr>
                        <tr className="font-normal">
                          <td>54</td>
                          <td>SAMARTH ANAND</td>
                          <td>JINDAL SCHOOL OF GOVERNMENT AND PUBLIC POLCY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>55</td>
                          <td>SHIVALI MISHRA</td>
                          <td>O P JINDAL</td>
                        </tr>
                        <tr className="font-normal">
                          <td>56</td>
                          <td>SONAKSHI KUMAR</td>
                          <td>SHIV NADAR UNIVERSITY NOIDA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>57</td>
                          <td>TAMMANA VIJ</td>
                          <td>OP JINDAL UNIVERSITY</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE INTERNATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/PRAATYUSH-GUPTA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">PRAATYUSH GUPTA</p>
                          <p>UNIVERSITY OF MARYLAND, COLLEGE PARK</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/PRANAV-SOBHANI.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">PRANAV SOBHANI</p>
                          <p>FIRST FACULTY, CHARLES UNIVERSITY, Prague, Czech Republic</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/RUBEN-DUA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">RUBEN DUA</p>
                          <p>SIMON FRASER UNIVERSITY, CANADA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/YANA-GUPTA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">YANA GUPTA</p>
                          <p>CHARLES UNIVERSITY (FIRST FACULTY), Prague, Czech Republic</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/NIHARIKA-RAJPUT.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">NIHARIKA RAJPUT</p>
                          <p>SEOUL NATIONAL UNIVERSITY/KYUNGPOOK NATIONAL UNIVERSITY</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-responsive table-view" border="1" width="100%">
                      <tbody>
                        <tr className="font-normal">
                          <th> S.No.</th>
                          <th>LEARNER’S&nbsp; NAME&nbsp;</th>
                          <th>COLLEGE/UNIVERSITY</th>
                        </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>PRAATYUSH GUPTA</td>
                          <td>UNIVERSITY OF MARYLAND, COLLEGE PARK</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>PRANAV SOBHANI</td>
                          <td>FIRST FACULTY, CHARLES UNIVERSITY, Prague, Czech Republic</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>RUBEN DUA</td>
                          <td>SIMON FRASER UNIVERSITY, CANADA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>YANA GUPTA</td>
                          <td>CHARLES UNIVERSITY (FIRST FACULTY), Prague, Czech Republic</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>NIHARIKA RAJPUT</td>
                          <td>SEOUL NATIONAL UNIVERSITY/KYUNGPOOK NATIONAL UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>ANSHUL YADAV</td>
                          <td>PENNYSYLVANIA STATE UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>CHAITANYA</td>
                          <td>ARIZONA STATE UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>8</td>
                          <td>AARAV KAPOOR</td>
                          <td>ST. MARY'S UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>9</td>
                          <td>NAVYA BAJAJ</td>
                          <td>UNIVERSITY OF WATERLOO</td>
                        </tr>
                        <tr className="font-normal">
                          <td>10</td>
                          <td>RAMJI SRINIVASAN</td>
                          <td>ST. MARY'S UNIVERSITY, Texas, USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>11</td>
                          <td>RIBHAV SINGH</td>
                          <td>SAUDER SCHOOL OF BUSINESS, UNIVERSITY OF BRITISH COLUMBIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>12</td>
                          <td>SAMEEP MAGOO</td>
                          <td>ST. MARY'S UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>13</td>
                          <td>SHAURYA AGGARWAL</td>
                          <td>MCMASTER UNIVERSITY, Ontario, Canada.</td>
                        </tr>
                        <tr className="font-normal">
                          <td>14</td>
                          <td>SRAJAN GAGRANI</td>
                          <td>UNIVERSITY OF LIVERPOOL, ENGLAND</td>
                        </tr>
                        <tr className="font-normal">
                          <td>15</td>
                          <td>AADITYA GUPTA</td>
                          <td>UNIVERSITY OF BRITISH COLUMBIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>16</td>
                          <td>ALAINA RARA</td>
                          <td>UNIVERSITY OF BRITISH COLUMBIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>17</td>
                          <td>CHAITANYA BANSAL</td>
                          <td>DU, LECEISTER SHIRE-QUEENHOLME-YARD, UK</td>
                        </tr>
                        <tr className="font-normal">
                          <td>18</td>
                          <td>GUL BHATIA</td>
                          <td>UNIVERSITY OF CALIFORNIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>19</td>
                          <td>ISHITA SHARMA</td>
                          <td>UNIVERSITY OF TORONTO</td>
                        </tr>
                        <tr className="font-normal">
                          <td>20</td>
                          <td>KASHISH OBEROI</td>
                          <td>YORK UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>21</td>
                          <td>UNNAT KALRA</td>
                          <td>UNIVERSITY OF SYDNEY</td>
                        </tr>
                        <tr className="font-normal">
                          <td>22</td>
                          <td>ELINA SINGH</td>
                          <td>SAVANNAH COLLEGE OF ART &amp; DESIGN</td>
                        </tr>
                        <tr className="font-normal">
                          <td>23</td>
                          <td>ANAVI KALKAL</td>
                          <td>UNIVERSITY OF BIRMINGHAM</td>
                        </tr>
                        <tr className="font-normal">
                          <td>24</td>
                          <td>RIYA BHANOT</td>
                          <td>UNIVERSITY OF WATERLOO</td>
                        </tr>
                        <tr className="font-normal">
                          <td>25</td>
                          <td>KRITI MALIK</td>
                          <td>SCIENCE PO LE HARVE CAMPUS, FRANCE</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {yearSelection === "5" && (
                <div class="">
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE NATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/TANISH-AGARWAL.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">TANISH AGARWAL</p>
                          <p>Indian Institute of Technology, Delhi</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ANIKET-SINGH.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ANIKET SINGH</p>
                          <p>Delhi Technological University</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/SHRIHARI-SHATRUGHAN.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SHRIHARI SHATRUGHAN</p>
                          <p>National Institute of Technology, Warangal</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/PRANAV-GOSWAMY.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">PRANAV GOSWAMY</p>
                          <p>National Institute of Fashion Technology</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/KRITI-SINGHAL.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">KRITI SINGHAL</p>
                          <p>Thapar Institute of Engineering and Technology</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr className="font-normal">
                          <th> S.No.</th>
                          <th>LEARNER’S&nbsp; NAME&nbsp;</th>
                          <th>COLLEGE/UNIVERSITY</th>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">1</td>
                          <td>TANISH AGARWAL</td>
                          <td>INDIAN INSTITUTE OF TECHNOLOGY, DELHI</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">2</td>
                          <td>ANIKET SINGH</td>
                          <td>Delhi Technological University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">3</td>
                          <td>SHRIHARI SHATRUGHAN</td>
                          <td>NATIONAL INSTITUTE OF TECHNOLOGY, WARANGAL</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">4</td>
                          <td>PRANAV GOSWAMY</td>
                          <td>NATIONAL INSTITUTE OF FASHION TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">5</td>
                          <td>KRITI SINGHAL</td>
                          <td>THAPAR INSTITUTE OF ENGINEERING AND TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">6</td>
                          <td>Tanya Singh</td>
                          <td>NIFT Campus Raibarelli shifted to Jodhpur</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">7</td>
                          <td>ADITYA BALLABH</td>
                          <td>MANIPAL INSTITUTE OF TECHNOLOGY</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">8</td>
                          <td>ANUSHKA KHURANA</td>
                          <td>NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">9</td>
                          <td>ARNAV CHAWLA</td>
                          <td>MANIPAL ACADEMY OF HIGHER EDUCATION (MAHE)</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">10</td>
                          <td>MITULA SAI SUBRAMANIAN</td>
                          <td>SCHOOL OF INTERWOVEN ARTS AND SCIENCES (SIAS)-KREA UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">11</td>
                          <td>SANIYA KAPOOR</td>
                          <td>AMITY INSTITUTE OF PSYCHOLOGY AND ALLIED SCIENCES, AMITY UNIVERSITY, NOIDA</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">12</td>
                          <td>KHUSHI ANAND</td>
                          <td>KAMLA NEHRU COLLEGE, DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">13</td>
                          <td>RHEAA NAIR</td>
                          <td>NMIMS SCHOOL OF LAW, MUMBAI</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">14</td>
                          <td>AKSHITA MAKIN</td>
                          <td>AMITY UNIVERSITY, NOIDA</td>
                        </tr>
                      </tbody></table>
                  </div>
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE INTERNATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/RITVIK-MINHAS.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">RITVIK MINHAS</p>
                          <p>University Of British Columbia, Vancouver, Canada</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/SONALI-GOEL.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SONALI GOEL</p>
                          <p>St. Hugh's College, University of Oxford</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/LAKSHITA-KHANNA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">LAKSHITA KHANNA</p>
                          <p>King's College, London</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ADITYA-SHARMA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">ADITYA SHARMA</p>
                          <p>Schulich School of Business, Canada</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/AMEYA-ASHISH-DEHADE.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">AMEYA ASHISH DEHADE</p>
                          <p>Johns Hopkins University, United States</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-responsive table-view" border="1" width="100%">
                      <tbody>
                        <tr className="font-normal">
                          <th> S.No.</th>
                          <th>LEARNER'S&nbsp; NAME&nbsp;</th>
                          <th>COLLEGE/UNIVERSITY</th>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">1</td>
                          <td>RITVIK MINHAS</td>
                          <td>UNIVERSITY OF BRITISH COLUMBIA, VANCOUVER, CANADA</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">2</td>
                          <td>SONALI GOEL</td>
                          <td>ST. HUGH'S COLLEGE, UNIVERSITY OF OXFORD</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">3</td>
                          <td>LAKSHITA KHANNA</td>
                          <td>KING'S COLLEGE, LONDON</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">4</td>
                          <td>ADITYA SHARMA</td>
                          <td>SCHULICH SCHOOL OF BUSINESS,CANADA</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">5</td>
                          <td>AMEYA ASHISH DEHADE</td>
                          <td>JOHNS HOPKINS UNIVERSITY, UNITED STATES</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">6</td>
                          <td>SANCHIT GUGLANI</td>
                          <td>UNIVERSITY OF WATERLOO</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">7</td>
                          <td>KARL ROHINTON SIDHWA</td>
                          <td>PURDUE UNIVERSITY</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">8</td>
                          <td>VANSHIKA SINGH</td>
                          <td>UNIVERSITY OF BRITISH COLUMBIA</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">9</td>
                          <td>SHRIDHAR SHATRUGHAN</td>
                          <td>UNIVERSITY OF TORONTO</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">10</td>
                          <td>ANSH GROVER</td>
                          <td>UNIVERSITY OF BRITISH COLUMBIA, VANCOUVER</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">11</td>
                          <td>ARNAV NAGPAL</td>
                          <td>UNIVERSITY OF WATERLOO</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {yearSelection === "6" && (
                <div class="" >
                  <div class="heading2 text-center">
                    <h4><b>NATIONAL ADMISSIONS 2018-19</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/RHEA-AGGARWAL.jpg" alt="Lotus Valley School, Gurgaon" className="img-fluid" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">RHEA AGGARWAL</p>
                          <p>Mahatma Gandhi Inst.of Medical Sciences</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/NANAKI-SINGH-AHLUWALIA.jpg" alt="Lotus Valley School, Gurgaon" className="img-fluid" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">NANAKI SINGH AHLUWALIA</p>
                          <p>Lady Shri Ram College for Women</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/NAVDHA-GROVER.jpg" alt="Lotus Valley School, Gurgaon" className="img-fluid" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">NAVDHA GROVER </p>
                          <p>NIFT,Delhi,Campus-Kangra,H.P</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/LAKSHITA-SINGH.jpg" alt="Lotus Valley School, Gurgaon" className="img-fluid" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">LAKSHITA SINGH</p>
                          <p>Miranda House, DU</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/MEHAK-BHATIA.jpg" alt="Lotus Valley School, Gurgaon" className="img-fluid" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">MEHAK BHATIA</p>
                          <p>Sri Venkateswara College, University of Delhi</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th> S.No.</th>
                        <th>LEARNER’S&nbsp; NAME&nbsp;</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal">
                          <td align="center">1</td>
                          <td>RHEA AGGARWAL&nbsp;</td>
                          <td>Mahatma Gandhi Institute of Medical Sciences</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">2</td>
                          <td>NANAKI SINGH AHLUWALIA</td>
                          <td>Lady Shri Ram College for Women</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">3</td>
                          <td>NAVDHA GROVER</td>
                          <td>NIFT, Delhi</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">4</td>
                          <td>LAKSHITA SINGH</td>
                          <td>Miranda House, University of Delhi</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">5</td>
                          <td>MEHAK BHATIA</td>
                          <td>Sri Venkateswara College, University of Delhi&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">6</td>
                          <td>ISHITA AGRAWAL</td>
                          <td>Shri Venkateshwara College , University of Delhi</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">7</td>
                          <td>ASHMEET KAUR GILL&nbsp;</td>
                          <td>IILM University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">8</td>
                          <td>CHANAKYA VIVEK KAPOOR&nbsp;</td>
                          <td>VIT</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">9</td>
                          <td>DHRUVA MALHOTRA&nbsp;</td>
                          <td>Amity University&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">10</td>
                          <td>ISHAN SHARMA&nbsp;</td>
                          <td>Ramjas College, University of Delhi&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">11</td>
                          <td>NAKUL KHANDELWAL&nbsp;</td>
                          <td>Narsee Monjee Institute of Management&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">12</td>
                          <td>SAMIKSHA BANSAL&nbsp;</td>
                          <td>Sushant School of Architecture&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">13</td>
                          <td>SIMRAN DEWAN&nbsp;</td>
                          <td>Thapar Institute of Engineering and Technology</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">14</td>
                          <td>AIMAN KALIA</td>
                          <td>Wistling Woods International&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">15</td>
                          <td>TRIBHUVAN GAHLOT</td>
                          <td>Manipal University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">16</td>
                          <td>SANYUKTA SINHA</td>
                          <td>VIT&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">17</td>
                          <td>PRATEEK KABRA</td>
                          <td>NIIT University&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">18</td>
                          <td>DHRUV CHAUHAN&nbsp;</td>
                          <td>Ramjas College, University of Delhi</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">19</td>
                          <td>VIDHI CHATURVEDI&nbsp;</td>
                          <td>Manipal University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">20</td>
                          <td>AMISHA</td>
                          <td>Indraprastha University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">21</td>
                          <td>MOLLY KALRA</td>
                          <td>Gargi College, University of Delhi</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">22</td>
                          <td>BHAVYA VERMA</td>
                          <td>IILM University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">23</td>
                          <td>PRANAV SAGAR VASISHTA</td>
                          <td>IILM University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">24</td>
                          <td>SIMRAN BAJAJ</td>
                          <td>Amity University&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">25</td>
                          <td>VEDANT</td>
                          <td>Ashoka University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">26</td>
                          <td>VANSHIKA DABRIWAL</td>
                          <td>Amity Law School</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">27</td>
                          <td>ANUSHKA ATREY TYAGI</td>
                          <td>IILM University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">28</td>
                          <td>ISHITA SHUKLA</td>
                          <td>Amity University&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">29</td>
                          <td>ANNU YADAV</td>
                          <td>Maitreyi College, University of Delhi</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">30</td>
                          <td>ADITHYA SATHYA</td>
                          <td>Atma Ram Sanatan Dharma College</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">31</td>
                          <td>HAZEL</td>
                          <td>IILM GURGAON</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">32</td>
                          <td>SATVIK CHATUEVEDI</td>
                          <td>Shiv Nadar University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">33</td>
                          <td>RAVIN GULATI</td>
                          <td>BML Munjal University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">34</td>
                          <td>ANOUSHKA KASHYAP</td>
                          <td>Atma Ram Sanatan Dharma College</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">35</td>
                          <td>DIYA THAKUR</td>
                          <td>SNDT ,Women's University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">36</td>
                          <td>SIDDHARTH KAPOOR</td>
                          <td>Flightrule Aviation(With Indigo Airlines)</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">37</td>
                          <td>ANIKETH GOVINDAN</td>
                          <td>Christ University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">38</td>
                          <td width="234">PINISETTY SAI SIDDHARTH</td>
                          <td>Christ University</td>
                        </tr>
                      </tbody></table>
                  </div>
                  <div class="heading2 text-center">
                    <h4><b>INTERNATIONAL ADMISSIONS 2018-19</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/MANAV-ANIL-GAGVANI.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">MANAV ANIL GAGVANI</p>
                          <p>Boston University</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/SHUCHITA-BEHL.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SHUCHITA BEHL</p>
                          <p>Macquarie University, Sydney, Australia</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/KRITIKA-SAINI.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">KRITIKA</p>
                          <p>Michigan State University</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/VEDANT-ARYA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">VEDANT ARYA</p>
                          <p>University Of British Columbia</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/SHREYA-DIWAN.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">SHREYA DIWAN</p>
                          <p>University of British Columbia</p>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th>&nbsp;S. NO.</th>
                        <th>LEARNER’S NAME</th>
                        <th>COLLEGE/&nbsp; UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal">
                          <td align="center">1</td>
                          <td>MANAV ANIL GAGVANI</td>
                          <td>Boston University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">2</td>
                          <td>SHUCHITA BEHL&nbsp;</td>
                          <td>Macquarie University, Sydney, Australia</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">3</td>
                          <td>KRITIKA</td>
                          <td>Michigan State University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">4</td>
                          <td>VEDANT ARYA</td>
                          <td>University of British Columbia</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">5</td>
                          <td>SHREYA DIWAN</td>
                          <td>University of British Columbia</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">6</td>
                          <td>KABIR HANSPAL</td>
                          <td>University of British Columbia</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">7</td>
                          <td>KANIKA SHARMA</td>
                          <td>University of British Columbia</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">8</td>
                          <td>NIKHIL YARRAM</td>
                          <td>University of Washington</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">9</td>
                          <td>SAUMYA DESAI</td>
                          <td>University of California&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">10</td>
                          <td>ARYAN MARWAH</td>
                          <td>University of Leiden,Hague ,Netherlands</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">11</td>
                          <td>ARYAN MATTA</td>
                          <td>University of Western Australia, Perth</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">12</td>
                          <td>PUNEET MATTA&nbsp;</td>
                          <td>Charles University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">13</td>
                          <td>RIYA NAIR</td>
                          <td>Middlesex University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">14</td>
                          <td>ARNAV MOHAN</td>
                          <td>University of Massachusetts, Amherst</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">15</td>
                          <td>ANSH CHAWLA</td>
                          <td>Asia Pacific University&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">16</td>
                          <td>RIDDHEE JUNNARKAR</td>
                          <td>University of Pretoria</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">17</td>
                          <td>VRINDA SINGH</td>
                          <td>London College of Fashion, University of the Arts , London</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">18</td>
                          <td>KSHITIJ TANDON&nbsp;</td>
                          <td>York University</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">19</td>
                          <td>TANISHKA LAKHOTIA</td>
                          <td>Georgia Institue of Technology</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">20</td>
                          <td>RISHABH&nbsp; GARG&nbsp;</td>
                          <td>Georgia Institute of Technology&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">21</td>
                          <td>TEJAS MAHAJAN</td>
                          <td>BITS Dubai</td>
                        </tr>
                        <tr className="font-normal">
                          <td align="center">22</td>
                          <td>PANKHURI AGARWAL</td>
                          <td>Indiana University</td>
                        </tr>
                      </tbody></table>
                  </div>
                </div>
              )}
              {yearSelection === "7" && (
                <div class="" >
                  <div class="heading2 text-center">
                    <h4><b>NATIONAL ADMISSIONS 2017-18</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/Anmol-jain.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">Anmol Jain</p>
                          <p>Gargi College, Delhi University</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/Jai-mehata.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">Jai Mehta</p>
                          <p>Dr.DY Patil Medical College,Hospital &amp;Research Centre,Pune</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/Jhanvi-Mehta.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">Jhanvi Mehta</p>
                          <p>Aryabhatta College, DU</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ronak.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">Ronak Singh</p>
                          <p>Shri Ram College of Commerce , Delhi University</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/Riya-Khanna.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">Riya Khanna</p>
                          <p>Jesus &amp; Mary College, Delhi University</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th> S.No.</th>
                        <th>LEARNER’S&nbsp; NAME&nbsp;</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>Aadya Vatus</td>
                          <td>D.Y Patil , Mumbai</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>Aman Vazirani</td>
                          <td>Bennett University, Grater Noida</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>Anmol Jain</td>
                          <td>Gargi College, Delhi University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>Arihant Jain</td>
                          <td>Manipal University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>Aryan Chugh</td>
                          <td>VIT ,Vellore</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>Bhavya Agarwal</td>
                          <td>Manipal Institute Of Technology</td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>Chahat Vasal</td>
                          <td>Manipal Institute Of Technology</td>
                        </tr>
                        <tr className="font-normal">
                          <td>8</td>
                          <td>Darika Jain</td>
                          <td>Bharati college, University Of Delhi</td>
                        </tr>
                        <tr className="font-normal">
                          <td>9</td>
                          <td>Hunar Ahlawat</td>
                          <td>Interglobe School, Greater Noida</td>
                        </tr>
                        <tr className="font-normal">
                          <td>11</td>
                          <td>Jai Mehta</td>
                          <td>Dr.DY Patil Medical College,Hospital &amp;Research Centre,Pune</td>
                        </tr>
                        <tr className="font-normal">
                          <td>12</td>
                          <td>Jhanvi Mehta</td>
                          <td>Aryabhatta College, DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>13</td>
                          <td>Nikhil Nayyar</td>
                          <td>HBT Medical College &amp; Dr.RN Cooper Municipal General Hospital</td>
                        </tr>
                        <tr className="font-normal">
                          <td>14</td>
                          <td>Riya Khanna</td>
                          <td>Jesus &amp; Mary College ,Delhi University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>15</td>
                          <td>Sakshi Mathur</td>
                          <td>D.Y PATIL , Pune</td>
                        </tr>
                        <tr className="font-normal">
                          <td>16</td>
                          <td>Ronak Singh</td>
                          <td>Shri Ram College of Commerce , Delhi University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>17</td>
                          <td>Amartya Paul</td>
                          <td>Vellore Institute Of Technology</td>
                        </tr>
                        <tr className="font-normal">
                          <td>18</td>
                          <td>Amogh Bansal</td>
                          <td>Srishti Institute of Design</td>
                        </tr>
                        <tr className="font-normal">
                          <td>19</td>
                          <td>Ananya Srivastava</td>
                          <td>Liberal Arts , NMIMS , Mumbai</td>
                        </tr>
                        <tr className="font-normal">
                          <td>20</td>
                          <td>Anoushca Laroia</td>
                          <td>Maharishi Markandeshwar Medical College , Solan, Himachal Pradesh</td>
                        </tr>
                        <tr className="font-normal">
                          <td>21</td>
                          <td>Anurag Ghosh</td>
                          <td>Amity University Noida</td>
                        </tr>
                        <tr className="font-normal">
                          <td>22</td>
                          <td>Arnav Gupta</td>
                          <td>Manipal University, Jaipur</td>
                        </tr>
                        <tr className="font-normal">
                          <td>23</td>
                          <td>Kavyasree Nerella</td>
                          <td>Institute of Hotel Management Pusa</td>
                        </tr>
                        <tr className="font-normal">
                          <td>24</td>
                          <td>Mohini Tandon</td>
                          <td>Nasaki Monjee Mumbai</td>
                        </tr>
                        <tr className="font-normal">
                          <td>25</td>
                          <td>Mrittika Adhikary</td>
                          <td>Acharya Narendra Dev College, University of Delhi</td>
                        </tr>
                        <tr className="font-normal">
                          <td>26</td>
                          <td>Shiv Jethi</td>
                          <td>Manipal University, Jaipur</td>
                        </tr>
                        <tr className="font-normal">
                          <td>27</td>
                          <td>Shyna Puri</td>
                          <td>Himalayan Institute Of Medical Sciences</td>
                        </tr>
                        <tr className="font-normal">
                          <td>28</td>
                          <td>Vidhant Bhaskar</td>
                          <td>Manipal Institute of Technology,Jaipur</td>
                        </tr>
                        <tr className="font-normal">
                          <td>29</td>
                          <td>Sanskrti Bansal</td>
                          <td>Symbiosis Law School,Symbiosis International University,Pune</td>
                        </tr>
                        <tr className="font-normal">
                          <td>30</td>
                          <td>Akriti Chowdhry</td>
                          <td>NID,Ahmedabad</td>
                        </tr>
                        <tr className="font-normal">
                          <td>31</td>
                          <td>Akshat Amitesh</td>
                          <td>Symbiosis Noida</td>
                        </tr>
                        <tr className="font-normal">
                          <td>32</td>
                          <td>Adit Ghai</td>
                          <td>Venkateshwar College</td>
                        </tr>
                        <tr className="font-normal">
                          <td>34</td>
                          <td>Anshul Dutt</td>
                          <td>O.P Jindal</td>
                        </tr>
                        <tr className="font-normal">
                          <td>35</td>
                          <td>Aryan S Oberoi</td>
                          <td>O P Jindal Symbiosis</td>
                        </tr>
                        <tr className="font-normal">
                          <td>36</td>
                          <td>Devyani Gupta</td>
                          <td>Bennett University,Noida</td>
                        </tr>
                        <tr className="font-normal">
                          <td>38</td>
                          <td>Deghpreet Kaur Lamba</td>
                          <td>Bennett University, Noida</td>
                        </tr>
                        <tr className="font-normal">
                          <td>39</td>
                          <td>Muskan Prabhakar</td>
                          <td>IILM University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>40</td>
                          <td>Smiti Wadhawan</td>
                          <td>Sushant School of Architecture,Ansal University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>41</td>
                          <td>Sreenidhi Vidyasagar</td>
                          <td>Jain University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>42</td>
                          <td>Srishti Johari</td>
                          <td>Amity University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>43</td>
                          <td>Yash Veer Chugh</td>
                          <td>O.P. Jindal Global University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>44</td>
                          <td>Sahil Kalra</td>
                          <td>Shaheed Bhagat Singh College</td>
                        </tr>
                        <tr className="font-normal">
                          <td>45</td>
                          <td>Disha Arora</td>
                          <td>IILM University, Gurgaon</td>
                        </tr>
                        <tr className="font-normal">
                          <td>46</td>
                          <td>Ashutosh Juneja</td>
                          <td>Aryabhatta college</td>
                        </tr>
                        <tr className="font-normal">
                          <td>48</td>
                          <td>Bhumika Sharma</td>
                          <td>Kamla Nehru College,Delhi</td>
                        </tr>
                        <tr className="font-normal">
                          <td>49</td>
                          <td>Eshaa Wahie</td>
                          <td>Miranda House,Delhi University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>50</td>
                          <td>Ishita Anand</td>
                          <td>Sophia College,Mumbai</td>
                        </tr>
                        <tr className="font-normal">
                          <td>51</td>
                          <td>Karan Arora</td>
                          <td>Amity University, Noida</td>
                        </tr>
                        <tr className="font-normal">
                          <td>52</td>
                          <td>Mahima Dutta</td>
                          <td>Symbiosis Law School,Hyderabad, Telangana</td>
                        </tr>
                        <tr className="font-normal">
                          <td>53</td>
                          <td>Misha Arora</td>
                          <td>Flame University, Pune</td>
                        </tr>
                        <tr className="font-normal">
                          <td>54</td>
                          <td>Sameeksha Kapoor</td>
                          <td>Sushant School Of Design,Gurgaon</td>
                        </tr>
                        <tr className="font-normal">
                          <td>55</td>
                          <td>Shubh Mukherji</td>
                          <td>Manipal University, Manipal</td>
                        </tr>
                      </tbody></table>
                  </div>
                  <div class="heading2 text-center">
                    <h4><b>INTERNATIONAL ADMISSIONS 2017-18</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/Arnav-Gupta.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">Arnav Gupta</p>
                          <p>New York University,New York</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/Jai-bhatia.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p className="font-normal">Jai Bhatia</p>
                          <p>University Of California, San Diego,USA</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/Vrishti-Misra.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Vrishti Misra</p>
                          <p>University Of British Columbia</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/Prarthana-sabharwal.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Prarthana Sabharwal</p>
                          <p>University Of Bath, London</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/NIRVIKALP-PURI.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Nirvikalp Puri</p>
                          <p>Trinity College </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th>&nbsp;S. NO.</th>
                        <th>LEARNER’S NAME</th>
                        <th>COLLEGE/&nbsp; UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>Arnav Gupta</td>
                          <td>New York University,New York</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>Jai Bhatia</td>
                          <td>University Of California, San Diego,USA</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>Gauri Saluja</td>
                          <td>Milan , Italy</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>Nirvikalp Puri</td>
                          <td>Trinity College</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>Prarthana Sabharwal</td>
                          <td>University Of Bath,London</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>Aayush Singh</td>
                          <td>Minerva University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>Agam Singh</td>
                          <td>Seneca College,Toronto</td>
                        </tr>
                        <tr className="font-normal">
                          <td>8</td>
                          <td>Uttara Srikanth</td>
                          <td>Anglia Ruskin University,Cambridge, UK</td>
                        </tr>
                        <tr className="font-normal">
                          <td>9</td>
                          <td>Vrishti Misra</td>
                          <td>University Of British Columbia</td>
                        </tr>
                      </tbody></table>
                  </div>
                </div>
              )}
              {yearSelection === "8" && (
                <div class="" >
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE NATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/AHAAN-AGARWAL.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>AHAAN AGARWAL</p>
                          <p>Shrishti Institute of Art, Design &amp; Technology</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ANOUSHKA-SINGHAL.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ANOUSHKA SINGHAL</p>
                          <p>Manipal Institute of Technology</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ARSH-ASHWINI-KUMAR.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ARSH KUMAR</p>
                          <p>Shrishti Institute of Art, Design &amp; Technology</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/BALAJI-SRINIVASAN.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>BALAJI SRINIVASAN</p>
                          <p>Vellore Institute of Technology</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ISHAAN-SINGH.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ISHAAN SINGH</p>
                          <p>Jindal Global Law School</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <td>S.NO.</td>
                        <td>NAME</td>
                        <td>COLLEGE/UNIVERSITY</td>
                      </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>AHAAN AGARWAL</td>
                          <td>Shrishti Institute of Art, Design &amp;Technology</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>ANOUSHKA SINGHAL</td>
                          <td>Manipal Institute of Technology&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>ARSH KUMAR</td>
                          <td>Shrishti Institute of Art, Design &amp;Technology</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>BALAJI SRINIVASAN</td>
                          <td>Vellore Institute of Technology</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>ISHAAN SINGH</td>
                          <td>Jindal Global Law School</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>NATASHA KUMAR</td>
                          <td>Manipal Institute of Technology&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>SHIVANI SHENOY</td>
                          <td>Shrishti Institute of Art,Design &amp;Technology</td>
                        </tr>
                        <tr className="font-normal">
                          <td>8</td>
                          <td>TANYA NIJHAWAN</td>
                          <td>Manipal Institute of Technology&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td>9</td>
                          <td>TANYA WAHI</td>
                          <td>Thapar University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>10</td>
                          <td>VANSHIKA</td>
                          <td>Shrishti Institute of Art,Design &amp;Technology</td>
                        </tr>
                        <tr className="font-normal">
                          <td>11</td>
                          <td>VASUNDHARA SHARMA</td>
                          <td>Pandit Deendayal Petroleum University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>12</td>
                          <td>VIPASHA VERMA</td>
                          <td>Thapar University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>13</td>
                          <td>ANANYA YADAV</td>
                          <td>Pandit Deendayal Petroleum University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>14</td>
                          <td>ADITYA MAHAJAN</td>
                          <td>OP Jindal College</td>
                        </tr>
                        <tr className="font-normal">
                          <td>15</td>
                          <td>CHETANYA JHINJHA</td>
                          <td>Jesus and Mary College</td>
                        </tr>
                        <tr className="font-normal">
                          <td>16</td>
                          <td>DEVINA POONIA</td>
                          <td>School of Law,Ansal University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>17</td>
                          <td>KANNAGI SOOD</td>
                          <td>Amity University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>18</td>
                          <td>KIMAYA NIGAM</td>
                          <td>Amity University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>19</td>
                          <td>MEHAK DHAWAN</td>
                          <td>Pearl Academy</td>
                        </tr>
                        <tr className="font-normal">
                          <td>20</td>
                          <td>MEHAK PREET KAUR MARWAH</td>
                          <td>Chanderpradhu Jain College School of Law</td>
                        </tr>
                        <tr className="font-normal">
                          <td>21</td>
                          <td>MOHIKA MUDGAL</td>
                          <td>Indian School of Business and Finance</td>
                        </tr>
                        <tr className="font-normal">
                          <td>22</td>
                          <td>NIKITA PANDEY</td>
                          <td>Bharti Vidyapeeth, Institute of Management and Entrepreneurship development</td>
                        </tr>
                        <tr className="font-normal">
                          <td>23</td>
                          <td>PRIYANKA RAO</td>
                          <td>Indian Institute of Art and Design</td>
                        </tr>
                        <tr className="font-normal">
                          <td>24</td>
                          <td>RASHI JAIN</td>
                          <td>OP Jindal College</td>
                        </tr>
                        <tr className="font-normal">
                          <td>25</td>
                          <td>SANYA BHALLA</td>
                          <td>Ansal University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>26</td>
                          <td>SAURAV DUTT</td>
                          <td>North Cap University (Institute of technology and Management)</td>
                        </tr>
                        <tr className="font-normal">
                          <td>27</td>
                          <td>SHEFALI MAYOR</td>
                          <td>JMC,DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>28</td>
                          <td>SHREYA SINHA</td>
                          <td>Christ University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>29</td>
                          <td>VIDHI AGARWAL</td>
                          <td>Shri Venkateshwara College</td>
                        </tr>
                        <tr className="font-normal">
                          <td>30</td>
                          <td>GURSHEEN K.SETHI</td>
                          <td>Amity University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>31</td>
                          <td>ABHAYJEET S KALER</td>
                          <td>Amity University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>32</td>
                          <td>ISHITA SHARMA</td>
                          <td>Hansraj College, University Of Delhi</td>
                        </tr>
                        <tr className="font-normal">
                          <td>33</td>
                          <td>GURNAAZ SINGH</td>
                          <td>NIIT University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>34</td>
                          <td>MAYANK KINGER</td>
                          <td>SRM University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>35</td>
                          <td>PARTH GUPTA</td>
                          <td>B.Tech,Cluster Innovation&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td>36</td>
                          <td>RIYA BHARGAVA</td>
                          <td>SGTB Khalsa, Buisness Economics Hons</td>
                        </tr>
                        <tr className="font-normal">
                          <td>37</td>
                          <td>NISHCHAL POPLI</td>
                          <td>Amity University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>38</td>
                          <td>ADIT JAIN</td>
                          <td>Christ University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>39</td>
                          <td>SAACHI KAUR MERWAH</td>
                          <td>Isdi Parsons</td>
                        </tr>
                      </tbody></table>
                  </div>
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE INTERNATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ARNAV-PRASAD.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ARNAV PRASAD</p>
                          <p>Oxford University</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/JASKARAN-SEHEMBEY.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>JASKARAN SEHMBEY</p>
                          <p>University of Queensland</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ASHITA-NITIN-BAWANKULE.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ASHITA BAWANKULE</p>
                          <p>Purdue University</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ANUJ-SACHDEVA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>ANUJ SACHDEVA </p>
                          <p>University of Waterloo</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/KABIR-SAWHNEY.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>KABIR SAWHNEY</p>
                          <p>University of Melbourne</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th>S.NO.</th>
                        <th>NAME</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>ARNAV PRASAD</td>
                          <td>Oxford University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>JASKARAN SEHMBEY</td>
                          <td>University of Queensland</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>ASHITA BAWANKULE</td>
                          <td>Purdue University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>ANUJ SACHDEVA</td>
                          <td>University of Waterloo</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>KABIR SAWHNEY</td>
                          <td>University of Melbourne</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>SWASTI AGNIHOTRI</td>
                          <td>University of Melbourne</td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>ENGILA KHAN</td>
                          <td>&nbsp;Gulf Medical University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>8</td>
                          <td>GINA KOHLI</td>
                          <td>Loughborough University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>9</td>
                          <td>HARSHA YADAV</td>
                          <td>University of New South Wales</td>
                        </tr>
                        <tr className="font-normal">
                          <td>10</td>
                          <td>RAUNAK SURANA</td>
                          <td>Singapore Institute of Management</td>
                        </tr>
                        <tr className="font-normal">
                          <td>11</td>
                          <td>AAYUSH GUPTA</td>
                          <td>Lancaster University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>12</td>
                          <td>SATVIIK MINHAS</td>
                          <td>Australian National University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>13</td>
                          <td>SHAASWAT R.KRISHNAN</td>
                          <td>University of Bath</td>
                        </tr>
                        <tr className="font-normal">
                          <td>14</td>
                          <td>MADHUR DHUPAR</td>
                          <td>Leiden university</td>
                        </tr>
                        <tr className="font-normal">
                          <td>15</td>
                          <td>UDITA GOEL</td>
                          <td>University of Minnesota</td>
                        </tr>
                        <tr className="font-normal">
                          <td>16</td>
                          <td>TARINNI S. KAKAR</td>
                          <td>Depauw University</td>
                        </tr>
                      </tbody></table>
                  </div>
                </div>
              )}
              {yearSelection === "9" && (
                <div class="">
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE NATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/VARUNAVI-BANGIA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Varunavi Bangia</p>
                          <p>The West Bengal National University of Juridical Sciences, Kolkata</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/SAYASHA-SHARMA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Sayasha Sharma</p>
                          <p>Lady Shri Ram College, DU</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/KAUSTAV-SOOD.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Kaustav Sood </p>
                          <p>Ashoka University</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ARUSHA-SINHA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Arusha Sinha </p>
                          <p>Ashoka University</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ABHIJEET-SINGH-SEHRA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Abhijeet S Sehra </p>
                          <p>SP Jain School of Global Management</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <td>S.NO.</td>
                        <td>NAME</td>
                        <td>COLLEGE/UNIVERSITY</td>
                      </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>Varunavi Bangia</td>
                          <td>The West Bengal National University of Juridical Sciences, Kolkata</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>Sayasha Sharma</td>
                          <td>Lady Shri Ram College, DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>Abhinav Majumder</td>
                          <td>Manipal Institute of Technology, Manipal, Udupi</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>Priyam Garg</td>
                          <td>Thapar Institute&nbsp; of Engineering and technology</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>Sanjhana Ramesh</td>
                          <td>VIT, University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>Kaustav Sood</td>
                          <td>Ashoka University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>Arusha Sinha</td>
                          <td>Ashoka University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>8</td>
                          <td>Abhijeet S Sehra</td>
                          <td>SP Jain School of Global Management</td>
                        </tr>
                        <tr className="font-normal">
                          <td>9</td>
                          <td>Sarthak Singh</td>
                          <td>Aryabhatta College, DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>10</td>
                          <td>Priyanshi Sinha&nbsp;</td>
                          <td>SRM University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>11</td>
                          <td>Srijan Malhotra</td>
                          <td>VIT, Vellore</td>
                        </tr>
                        <tr className="font-normal">
                          <td>12</td>
                          <td>Zoya Khanday</td>
                          <td>Delhi college of Arts and Commerce, DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>13</td>
                          <td>Chenab Balwan</td>
                          <td>SVKM’s NMIMS <br />
                            ( Narsee Monjee Institute of Management Studies) </td>
                        </tr>
                        <tr className="font-normal">
                          <td>14</td>
                          <td>Komal Srivastava</td>
                          <td>BAMC Course, School of communication, Manipal University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>15</td>
                          <td>Neha Singhal</td>
                          <td>Aurobindo College(C.S Foundation)</td>
                        </tr>
                        <tr className="font-normal">
                          <td>16</td>
                          <td>Tasavur Singh</td>
                          <td>Delhi University, (School of Open learning)</td>
                        </tr>
                        <tr className="font-normal">
                          <td>17</td>
                          <td>Kartikaye Yadav</td>
                          <td>Sushant school of Art and Architecture, Ansal University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>18</td>
                          <td>Shreya Sharma</td>
                          <td>School of Liberal Studies,Pandit Deendayal Petroleum University.</td>
                        </tr>
                        <tr className="font-normal">
                          <td>19</td>
                          <td>Devika Singh</td>
                          <td>SGT Dental and Medical University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>20</td>
                          <td>Namrata Kukreja</td>
                          <td>Jindal Global Law School</td>
                        </tr>
                        <tr className="font-normal">
                          <td>21</td>
                          <td>Sahejbir Kumar Singh</td>
                          <td>SRM University,(Computer Engineering)</td>
                        </tr>
                        <tr className="font-normal">
                          <td>22</td>
                          <td>Amit Sangwan</td>
                          <td>Punjab University,Chandigarh</td>
                        </tr>
                        <tr className="font-normal">
                          <td>23</td>
                          <td>Gaurangi Khanna</td>
                          <td>National Law University, Cuttak</td>
                        </tr>
                        <tr className="font-normal">
                          <td>24</td>
                          <td>Shriya Jangid</td>
                          <td>Dayal Singh College, Delhi University(B.Com)</td>
                        </tr>
                        <tr className="font-normal">
                          <td>25</td>
                          <td>Vidit Arora</td>
                          <td>Aryabhatta College, South Campus, DU</td>
                        </tr>
                        <tr className="font-normal">
                          <td>26</td>
                          <td>Kapish Singhal&nbsp;</td>
                          <td>Ansal University, School of Law</td>
                        </tr>
                        <tr className="font-normal">
                          <td>27</td>
                          <td>Aditya Jain</td>
                          <td>Amity University</td>
                        </tr>
                        <tr className="font-normal">
                          <td>28</td>
                          <td>Aarush Rustagi</td>
                          <td>The Northcap University</td>
                        </tr>
                      </tbody></table>
                  </div>
                  <div class="heading2 text-center">
                    <h4><b>ADMISSIONS AT THE INTERNATIONAL LEVEL</b></h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/ANUTTARA-BAKAYA.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Anuttara Bakaya </p>
                          <p>Illinois Institute of Technology, Chicago</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/JYOTIKA-PURI.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Jyotika Puri </p>
                          <p>National University of Singapore</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/MOLLY-RATHORE.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Molly Rathore </p>
                          <p>University of Hongkong(HKU) </p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/RISHAV-CHAKRABORTY.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Rishav Chakraborty </p>
                          <p>Monash University, Melbourne , Australia</p>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/UTKARSH-KESWANI.jpg" className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
                        </div>
                        <div class="gallery-text">
                          <p>Utkarsh Keswani</p>
                          <p>University of Western Australia</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody><tr>
                        <th>S.NO.</th>
                        <th>NAME</th>
                        <th>COLLEGE/UNIVERSITY</th>
                      </tr>
                        <tr className="font-normal">
                          <td>1</td>
                          <td>Anuttara Bakaya</td>
                          <td>Illinois Institute of Technology, Chicago</td>
                        </tr>
                        <tr className="font-normal">
                          <td>2</td>
                          <td>Jyotika Puri</td>
                          <td>National University of Singapore</td>
                        </tr>
                        <tr className="font-normal">
                          <td>3</td>
                          <td>Molly Rathore</td>
                          <td>University of Hongkong(HKU)&nbsp;</td>
                        </tr>
                        <tr className="font-normal">
                          <td>4</td>
                          <td>Rishav Chakraborty</td>
                          <td>Monash University, Melbourne , Australia</td>
                        </tr>
                        <tr className="font-normal">
                          <td>5</td>
                          <td>Utkarsh Keswani</td>
                          <td>University of Western Australia</td>
                        </tr>
                        <tr className="font-normal">
                          <td>6</td>
                          <td>Shivangi Chand</td>
                          <td>University of Purdue,Indiana</td>
                        </tr>
                        <tr className="font-normal">
                          <td>7</td>
                          <td>Ishnoor Singh Ahuja</td>
                          <td>University of Groningen, Netherlands</td>
                        </tr>
                      </tbody></table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
      <Footer />
    </>
  )
}
export default Admission